const mockSleepData = [
  {
    _id: '62a7f19bfc13ae7eb8000000',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-01 20:18:02',
    sleepStart: '2022-01-01 20:18:02',
    sleepEnd: '2022-01-02 08:48:19',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '12:30:17',
    notesSleep:
      'duis faucibus accumsan odio curabitur convallis duis consequat',
    notesWake: 'aliquam convallis nunc proin at turpis',
  },
  {
    _id: '62a7f19bfc13ae7eb8000001',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-02 20:07:44',
    sleepStart: '2022-01-02 20:07:44',
    sleepEnd: '2022-01-03 10:53:42',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '14:45:58',
    notesSleep: 'semper est quam pharetra magna ac consequat',
    notesWake: 'ipsum dolor sit amet consectetuer adipiscing',
  },
  {
    _id: '62a7f19bfc13ae7eb8000002',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-03 20:08:05',
    sleepStart: '2022-01-03 20:08:05',
    sleepEnd: '2022-01-04 10:31:51',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '14:23:46',
    notesSleep: 'a suscipit nulla elit ac',
    notesWake: 'neque aenean auctor gravida sem',
  },
  {
    _id: '62a7f19bfc13ae7eb8000003',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-04 20:30:44',
    sleepStart: '2022-01-04 20:30:44',
    sleepEnd: '2022-01-05 10:46:14',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '14:15:30',
    notesSleep: 'et magnis dis parturient montes nascetur ridiculus mus',
    notesWake: 'eleifend quam a odio in',
  },
  {
    _id: '62a7f19bfc13ae7eb8000004',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-05 22:07:20',
    sleepStart: '2022-01-05 22:07:20',
    sleepEnd: '2022-01-06 09:55:26',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '11:48:06',
    notesSleep: 'consequat dui nec nisi volutpat eleifend',
    notesWake: 'odio donec vitae nisi nam ultrices',
  },
  {
    _id: '62a7f19bfc13ae7eb8000005',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-06 23:02:41',
    sleepStart: '2022-01-06 23:02:41',
    sleepEnd: '2022-01-07 09:14:33',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '10:11:52',
    notesSleep: 'nisl duis ac nibh fusce lacus purus aliquet',
    notesWake: 'vestibulum ante ipsum primis in faucibus',
  },
  {
    _id: '62a7f19bfc13ae7eb8000006',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-07 21:37:00',
    sleepStart: '2022-01-07 21:37:00',
    sleepEnd: '2022-01-08 06:51:14',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '09:14:14',
    notesSleep: 'quam nec dui luctus rutrum nulla tellus in',
    notesWake: 'eu tincidunt in leo maecenas pulvinar lobortis est',
  },
  {
    _id: '62a7f19bfc13ae7eb8000007',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-08 22:12:24',
    sleepStart: '2022-01-08 22:12:24',
    sleepEnd: '2022-01-09 06:44:00',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '08:31:36',
    notesSleep: 'integer pede justo lacinia eget tincidunt eget tempus',
    notesWake: 'velit vivamus vel nulla eget eros',
  },
  {
    _id: '62a7f19bfc13ae7eb8000008',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-09 23:58:38',
    sleepStart: '2022-01-09 23:58:38',
    sleepEnd: '2022-01-10 10:51:30',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '10:52:52',
    notesSleep: 'nulla suspendisse potenti cras in purus eu',
    notesWake: 'at diam nam tristique tortor',
  },
  {
    _id: '62a7f19bfc13ae7eb8000009',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-10 20:48:08',
    sleepStart: '2022-01-10 20:48:08',
    sleepEnd: '2022-01-11 06:39:10',
    moodStart: 1,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '09:51:02',
    notesSleep: 'placerat ante nulla justo aliquam quis turpis eget',
    notesWake: 'diam cras pellentesque volutpat dui maecenas tristique',
  },
  {
    _id: '62a7f19bfc13ae7eb800000a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-11 23:53:15',
    sleepStart: '2022-01-11 23:53:15',
    sleepEnd: '2022-01-12 10:19:32',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '10:26:17',
    notesSleep: 'arcu sed augue aliquam erat volutpat in',
    notesWake: 'aliquet at feugiat non pretium',
  },
  {
    _id: '62a7f19bfc13ae7eb800000b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-12 22:15:54',
    sleepStart: '2022-01-12 22:15:54',
    sleepEnd: '2022-01-13 10:51:55',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '12:36:01',
    notesSleep: 'quam suspendisse potenti nullam porttitor lacus',
    notesWake: 'nonummy integer non velit donec diam neque',
  },
  {
    _id: '62a7f19bfc13ae7eb800000c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-13 21:22:56',
    sleepStart: '2022-01-13 21:22:56',
    sleepEnd: '2022-01-14 06:29:49',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '09:06:53',
    notesSleep: 'et ultrices posuere cubilia curae',
    notesWake: 'sed vestibulum sit amet cursus id',
  },
  {
    _id: '62a7f19bfc13ae7eb800000d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-14 21:10:15',
    sleepStart: '2022-01-14 21:10:15',
    sleepEnd: '2022-01-15 06:42:40',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '09:32:25',
    notesSleep: 'tempor turpis nec euismod scelerisque quam',
    notesWake: 'dolor sit amet consectetuer adipiscing elit proin risus',
  },
  {
    _id: '62a7f19bfc13ae7eb800000e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-15 22:18:45',
    sleepStart: '2022-01-15 22:18:45',
    sleepEnd: '2022-01-16 10:32:58',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '12:14:13',
    notesSleep: 'felis donec semper sapien a',
    notesWake: 'lorem vitae mattis nibh ligula',
  },
  {
    _id: '62a7f19bfc13ae7eb800000f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-16 23:50:37',
    sleepStart: '2022-01-16 23:50:37',
    sleepEnd: '2022-01-17 09:24:40',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '09:34:03',
    notesSleep: 'tortor sollicitudin mi sit amet lobortis sapien',
    notesWake: 'rutrum at lorem integer tincidunt ante vel',
  },
  {
    _id: '62a7f19bfc13ae7eb8000010',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-17 21:04:48',
    sleepStart: '2022-01-17 21:04:48',
    sleepEnd: '2022-01-18 08:50:46',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '11:45:58',
    notesSleep: 'justo sit amet sapien dignissim',
    notesWake: 'nulla dapibus dolor vel est donec odio',
  },
  {
    _id: '62a7f19bfc13ae7eb8000011',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-18 23:57:34',
    sleepStart: '2022-01-18 23:57:34',
    sleepEnd: '2022-01-19 08:20:06',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '08:22:32',
    notesSleep: 'ipsum primis in faucibus orci luctus et ultrices',
    notesWake: 'parturient montes nascetur ridiculus mus etiam',
  },
  {
    _id: '62a7f19bfc13ae7eb8000012',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-19 23:57:25',
    sleepStart: '2022-01-19 23:57:25',
    sleepEnd: '2022-01-20 08:49:12',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '08:51:47',
    notesSleep: 'ante ipsum primis in faucibus orci luctus',
    notesWake: 'at dolor quis odio consequat varius integer ac',
  },
  {
    _id: '62a7f19bfc13ae7eb8000013',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-20 23:41:25',
    sleepStart: '2022-01-20 23:41:25',
    sleepEnd: '2022-01-21 10:54:09',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '11:12:44',
    notesSleep: 'justo maecenas rhoncus aliquam lacus morbi quis',
    notesWake: 'vel ipsum praesent blandit lacinia',
  },
  {
    _id: '62a7f19bfc13ae7eb8000014',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-21 23:32:51',
    sleepStart: '2022-01-21 23:32:51',
    sleepEnd: '2022-01-22 09:10:48',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '09:37:57',
    notesSleep:
      'pharetra magna vestibulum aliquet ultrices erat tortor sollicitudin',
    notesWake: 'nunc nisl duis bibendum felis',
  },
  {
    _id: '62a7f19bfc13ae7eb8000015',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-22 21:41:35',
    sleepStart: '2022-01-22 21:41:35',
    sleepEnd: '2022-01-23 08:43:21',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '11:01:46',
    notesSleep: 'id lobortis convallis tortor risus',
    notesWake: 'ante ipsum primis in faucibus',
  },
  {
    _id: '62a7f19bfc13ae7eb8000016',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-23 23:07:01',
    sleepStart: '2022-01-23 23:07:01',
    sleepEnd: '2022-01-24 07:50:37',
    moodStart: 2,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '08:43:36',
    notesSleep: 'justo in blandit ultrices enim lorem ipsum',
    notesWake: 'mauris ullamcorper purus sit amet nulla',
  },
  {
    _id: '62a7f19bfc13ae7eb8000017',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-24 23:26:35',
    sleepStart: '2022-01-24 23:26:35',
    sleepEnd: '2022-01-25 09:00:26',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '09:33:51',
    notesSleep: 'ipsum aliquam non mauris morbi non',
    notesWake: 'massa id nisl venenatis lacinia aenean sit',
  },
  {
    _id: '62a7f19bfc13ae7eb8000018',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-25 21:23:25',
    sleepStart: '2022-01-25 21:23:25',
    sleepEnd: '2022-01-26 10:44:10',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '13:20:45',
    notesSleep: 'eu felis fusce posuere felis',
    notesWake: 'congue risus semper porta volutpat quam pede',
  },
  {
    _id: '62a7f19bfc13ae7eb8000019',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-26 21:42:15',
    sleepStart: '2022-01-26 21:42:15',
    sleepEnd: '2022-01-27 06:10:35',
    moodStart: 1,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '08:28:20',
    notesSleep: 'odio condimentum id luctus nec molestie sed justo',
    notesWake: 'venenatis turpis enim blandit mi in porttitor pede',
  },
  {
    _id: '62a7f19bfc13ae7eb800001a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-27 22:54:28',
    sleepStart: '2022-01-27 22:54:28',
    sleepEnd: '2022-01-28 09:08:17',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '10:13:49',
    notesSleep: 'id massa id nisl venenatis',
    notesWake: 'ridiculus mus vivamus vestibulum sagittis sapien',
  },
  {
    _id: '62a7f19bfc13ae7eb800001b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-28 23:22:26',
    sleepStart: '2022-01-28 23:22:26',
    sleepEnd: '2022-01-29 08:20:00',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '08:57:34',
    notesSleep: 'justo maecenas rhoncus aliquam lacus morbi',
    notesWake: 'donec posuere metus vitae ipsum aliquam',
  },
  {
    _id: '62a7f19bfc13ae7eb800001c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-29 22:33:15',
    sleepStart: '2022-01-29 22:33:15',
    sleepEnd: '2022-01-30 09:42:42',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '11:09:27',
    notesSleep: 'nunc vestibulum ante ipsum primis in faucibus',
    notesWake: 'magna vulputate luctus cum sociis natoque penatibus',
  },
  {
    _id: '62a7f19bfc13ae7eb800001d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-30 21:21:24',
    sleepStart: '2022-01-30 21:21:24',
    sleepEnd: '2022-01-31 09:38:50',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '12:17:26',
    notesSleep: 'auctor gravida sem praesent id',
    notesWake: 'integer a nibh in quis justo maecenas',
  },
  {
    _id: '62a7f19bfc13ae7eb800001e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-01-31 21:21:45',
    sleepStart: '2022-01-31 21:21:45',
    sleepEnd: '2022-02-01 09:29:55',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '12:08:10',
    notesSleep: 'eu magna vulputate luctus cum sociis natoque penatibus',
    notesWake: 'curae mauris viverra diam vitae quam suspendisse',
  },
  {
    _id: '62a7f19bfc13ae7eb800001f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-01 20:47:37',
    sleepStart: '2022-02-01 20:47:37',
    sleepEnd: '2022-02-02 10:04:26',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '13:16:49',
    notesSleep: 'sed interdum venenatis turpis enim blandit',
    notesWake: 'vel sem sed sagittis nam congue risus',
  },
  {
    _id: '62a7f19bfc13ae7eb8000020',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-02 21:21:54',
    sleepStart: '2022-02-02 21:21:54',
    sleepEnd: '2022-02-03 09:44:35',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '12:22:41',
    notesSleep: 'justo nec condimentum neque sapien',
    notesWake: 'natoque penatibus et magnis dis parturient montes',
  },
  {
    _id: '62a7f19bfc13ae7eb8000021',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-03 21:39:10',
    sleepStart: '2022-02-03 21:39:10',
    sleepEnd: '2022-02-04 09:21:20',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '11:42:10',
    notesSleep: 'erat quisque erat eros viverra eget congue',
    notesWake: 'curabitur gravida nisi at nibh',
  },
  {
    _id: '62a7f19bfc13ae7eb8000022',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-04 20:05:27',
    sleepStart: '2022-02-04 20:05:27',
    sleepEnd: '2022-02-05 09:10:04',
    moodStart: 2,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '13:04:37',
    notesSleep: 'at velit vivamus vel nulla eget eros elementum',
    notesWake: 'justo lacinia eget tincidunt eget tempus vel',
  },
  {
    _id: '62a7f19bfc13ae7eb8000023',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-05 21:10:56',
    sleepStart: '2022-02-05 21:10:56',
    sleepEnd: '2022-02-06 09:50:45',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '12:39:49',
    notesSleep: 'viverra pede ac diam cras pellentesque',
    notesWake: 'semper rutrum nulla nunc purus phasellus in',
  },
  {
    _id: '62a7f19bfc13ae7eb8000024',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-06 21:52:10',
    sleepStart: '2022-02-06 21:52:10',
    sleepEnd: '2022-02-07 10:27:44',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '12:35:34',
    notesSleep: 'duis aliquam convallis nunc proin at turpis a',
    notesWake: 'nunc vestibulum ante ipsum primis in faucibus orci',
  },
  {
    _id: '62a7f19bfc13ae7eb8000025',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-07 22:40:36',
    sleepStart: '2022-02-07 22:40:36',
    sleepEnd: '2022-02-08 06:23:08',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '07:42:32',
    notesSleep: 'luctus nec molestie sed justo',
    notesWake: 'ultrices posuere cubilia curae mauris',
  },
  {
    _id: '62a7f19bfc13ae7eb8000026',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-08 20:25:06',
    sleepStart: '2022-02-08 20:25:06',
    sleepEnd: '2022-02-09 06:04:56',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '09:39:50',
    notesSleep: 'lorem ipsum dolor sit amet consectetuer',
    notesWake: 'neque duis bibendum morbi non quam nec dui',
  },
  {
    _id: '62a7f19bfc13ae7eb8000027',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-09 20:17:36',
    sleepStart: '2022-02-09 20:17:36',
    sleepEnd: '2022-02-10 09:27:40',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '13:10:04',
    notesSleep: 'non velit nec nisi vulputate nonummy maecenas tincidunt',
    notesWake: 'amet cursus id turpis integer aliquet massa id',
  },
  {
    _id: '62a7f19bfc13ae7eb8000028',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-10 23:26:24',
    sleepStart: '2022-02-10 23:26:24',
    sleepEnd: '2022-02-11 09:20:37',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '09:54:13',
    notesSleep: 'eleifend quam a odio in',
    notesWake: 'erat curabitur gravida nisi at nibh in hac',
  },
  {
    _id: '62a7f19bfc13ae7eb8000029',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-11 22:54:23',
    sleepStart: '2022-02-11 22:54:23',
    sleepEnd: '2022-02-12 07:00:56',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '08:06:33',
    notesSleep: 'urna pretium nisl ut volutpat sapien arcu sed',
    notesWake: 'quis odio consequat varius integer ac',
  },
  {
    _id: '62a7f19bfc13ae7eb800002a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-12 22:53:02',
    sleepStart: '2022-02-12 22:53:02',
    sleepEnd: '2022-02-13 10:48:27',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '11:55:25',
    notesSleep: 'augue luctus tincidunt nulla mollis molestie lorem',
    notesWake: 'lacinia nisi venenatis tristique fusce congue',
  },
  {
    _id: '62a7f19bfc13ae7eb800002b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-13 21:19:42',
    sleepStart: '2022-02-13 21:19:42',
    sleepEnd: '2022-02-14 07:40:13',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '10:20:31',
    notesSleep: 'rhoncus mauris enim leo rhoncus sed',
    notesWake: 'sapien dignissim vestibulum vestibulum ante ipsum primis',
  },
  {
    _id: '62a7f19bfc13ae7eb800002c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-14 21:07:01',
    sleepStart: '2022-02-14 21:07:01',
    sleepEnd: '2022-02-15 09:46:55',
    moodStart: 1,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '12:39:54',
    notesSleep: 'praesent lectus vestibulum quam sapien',
    notesWake: 'vel sem sed sagittis nam',
  },
  {
    _id: '62a7f19bfc13ae7eb800002d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-15 20:27:12',
    sleepStart: '2022-02-15 20:27:12',
    sleepEnd: '2022-02-16 10:04:17',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '13:37:05',
    notesSleep: 'vehicula condimentum curabitur in libero',
    notesWake: 'ultrices libero non mattis pulvinar nulla pede ullamcorper',
  },
  {
    _id: '62a7f19bfc13ae7eb800002e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-16 20:22:28',
    sleepStart: '2022-02-16 20:22:28',
    sleepEnd: '2022-02-17 06:56:40',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '10:34:12',
    notesSleep: 'donec ut dolor morbi vel',
    notesWake: 'phasellus in felis donec semper sapien',
  },
  {
    _id: '62a7f19bfc13ae7eb800002f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-17 20:29:07',
    sleepStart: '2022-02-17 20:29:07',
    sleepEnd: '2022-02-18 06:31:47',
    moodStart: 2,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '10:02:40',
    notesSleep: 'nibh in quis justo maecenas rhoncus aliquam',
    notesWake: 'scelerisque mauris sit amet eros suspendisse',
  },
  {
    _id: '62a7f19bfc13ae7eb8000030',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-18 20:48:11',
    sleepStart: '2022-02-18 20:48:11',
    sleepEnd: '2022-02-19 06:27:32',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '09:39:21',
    notesSleep: 'justo in hac habitasse platea dictumst',
    notesWake: 'imperdiet sapien urna pretium nisl ut volutpat sapien',
  },
  {
    _id: '62a7f19bfc13ae7eb8000031',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-19 20:12:53',
    sleepStart: '2022-02-19 20:12:53',
    sleepEnd: '2022-02-20 09:53:19',
    moodStart: 0,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '13:40:26',
    notesSleep: 'volutpat eleifend donec ut dolor morbi',
    notesWake: 'vitae nisl aenean lectus pellentesque eget',
  },
  {
    _id: '62a7f19bfc13ae7eb8000032',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-20 23:11:16',
    sleepStart: '2022-02-20 23:11:16',
    sleepEnd: '2022-02-21 08:41:22',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '09:30:06',
    notesSleep: 'sed tincidunt eu felis fusce posuere',
    notesWake: 'vestibulum eget vulputate ut ultrices vel',
  },
  {
    _id: '62a7f19bfc13ae7eb8000033',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-21 22:49:42',
    sleepStart: '2022-02-21 22:49:42',
    sleepEnd: '2022-02-22 07:40:34',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '08:50:52',
    notesSleep: 'nisi nam ultrices libero non mattis',
    notesWake: 'amet sem fusce consequat nulla nisl nunc',
  },
  {
    _id: '62a7f19bfc13ae7eb8000034',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-22 22:09:37',
    sleepStart: '2022-02-22 22:09:37',
    sleepEnd: '2022-02-23 09:59:35',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '11:49:58',
    notesSleep: 'semper rutrum nulla nunc purus phasellus',
    notesWake: 'sed accumsan felis ut at dolor quis',
  },
  {
    _id: '62a7f19bfc13ae7eb8000035',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-23 20:18:29',
    sleepStart: '2022-02-23 20:18:29',
    sleepEnd: '2022-02-24 06:51:37',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '10:33:08',
    notesSleep: 'eu mi nulla ac enim in tempor turpis',
    notesWake: 'purus phasellus in felis donec',
  },
  {
    _id: '62a7f19bfc13ae7eb8000036',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-24 20:53:47',
    sleepStart: '2022-02-24 20:53:47',
    sleepEnd: '2022-02-25 10:47:26',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '13:53:39',
    notesSleep: 'morbi porttitor lorem id ligula suspendisse ornare',
    notesWake: 'rutrum nulla tellus in sagittis dui vel nisl',
  },
  {
    _id: '62a7f19bfc13ae7eb8000037',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-25 23:58:23',
    sleepStart: '2022-02-25 23:58:23',
    sleepEnd: '2022-02-26 07:16:29',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '07:18:06',
    notesSleep: 'ut volutpat sapien arcu sed augue aliquam',
    notesWake: 'faucibus orci luctus et ultrices posuere',
  },
  {
    _id: '62a7f19bfc13ae7eb8000038',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-26 22:42:54',
    sleepStart: '2022-02-26 22:42:54',
    sleepEnd: '2022-02-27 09:40:36',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '10:57:42',
    notesSleep: 'ac consequat metus sapien ut',
    notesWake: 'in felis donec semper sapien',
  },
  {
    _id: '62a7f19bfc13ae7eb8000039',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-27 23:50:24',
    sleepStart: '2022-02-27 23:50:24',
    sleepEnd: '2022-02-28 09:55:01',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '10:04:37',
    notesSleep: 'sociis natoque penatibus et magnis dis',
    notesWake: 'massa quis augue luctus tincidunt nulla mollis molestie',
  },
  {
    _id: '62a7f19bfc13ae7eb800003a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-02-28 21:41:21',
    sleepStart: '2022-02-28 21:41:21',
    sleepEnd: '2022-03-01 06:10:38',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '08:29:17',
    notesSleep: 'volutpat eleifend donec ut dolor',
    notesWake: 'est risus auctor sed tristique',
  },
  {
    _id: '62a7f19bfc13ae7eb800003b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-01 23:01:35',
    sleepStart: '2022-03-01 23:01:35',
    sleepEnd: '2022-03-02 08:32:30',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '09:30:55',
    notesSleep: 'purus aliquet at feugiat non pretium quis',
    notesWake: 'ut blandit non interdum in ante vestibulum',
  },
  {
    _id: '62a7f19bfc13ae7eb800003c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-02 21:27:49',
    sleepStart: '2022-03-02 21:27:49',
    sleepEnd: '2022-03-03 09:27:47',
    moodStart: 3,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '11:59:58',
    notesSleep: 'non mauris morbi non lectus',
    notesWake: 'accumsan odio curabitur convallis duis consequat dui',
  },
  {
    _id: '62a7f19bfc13ae7eb800003d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-03 23:18:46',
    sleepStart: '2022-03-03 23:18:46',
    sleepEnd: '2022-03-04 08:43:52',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '09:25:06',
    notesSleep: 'nulla tempus vivamus in felis eu sapien',
    notesWake: 'nisl ut volutpat sapien arcu sed augue aliquam',
  },
  {
    _id: '62a7f19bfc13ae7eb800003e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-04 22:20:53',
    sleepStart: '2022-03-04 22:20:53',
    sleepEnd: '2022-03-05 09:33:22',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '11:12:29',
    notesSleep: 'aenean lectus pellentesque eget nunc donec',
    notesWake: 'est lacinia nisi venenatis tristique fusce congue',
  },
  {
    _id: '62a7f19bfc13ae7eb800003f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-05 20:09:34',
    sleepStart: '2022-03-05 20:09:34',
    sleepEnd: '2022-03-06 09:40:27',
    moodStart: 3,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '13:30:53',
    notesSleep: 'non lectus aliquam sit amet diam in',
    notesWake: 'pede morbi porttitor lorem id ligula',
  },
  {
    _id: '62a7f19bfc13ae7eb8000040',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-06 21:36:59',
    sleepStart: '2022-03-06 21:36:59',
    sleepEnd: '2022-03-07 07:29:56',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '09:52:57',
    notesSleep: 'magnis dis parturient montes nascetur',
    notesWake: 'nec molestie sed justo pellentesque viverra pede ac',
  },
  {
    _id: '62a7f19bfc13ae7eb8000041',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-07 23:12:35',
    sleepStart: '2022-03-07 23:12:35',
    sleepEnd: '2022-03-08 08:32:38',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '09:20:03',
    notesSleep: 'lacinia sapien quis libero nullam sit',
    notesWake: 'donec pharetra magna vestibulum aliquet ultrices erat',
  },
  {
    _id: '62a7f19bfc13ae7eb8000042',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-08 20:25:25',
    sleepStart: '2022-03-08 20:25:25',
    sleepEnd: '2022-03-09 09:40:54',
    moodStart: 2,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '13:15:29',
    notesSleep: 'lectus pellentesque eget nunc donec',
    notesWake: 'nec condimentum neque sapien placerat ante nulla',
  },
  {
    _id: '62a7f19bfc13ae7eb8000043',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-09 20:59:43',
    sleepStart: '2022-03-09 20:59:43',
    sleepEnd: '2022-03-10 09:53:27',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '12:53:44',
    notesSleep: 'lectus in quam fringilla rhoncus mauris enim',
    notesWake: 'justo sit amet sapien dignissim vestibulum vestibulum',
  },
  {
    _id: '62a7f19bfc13ae7eb8000044',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-10 23:46:00',
    sleepStart: '2022-03-10 23:46:00',
    sleepEnd: '2022-03-11 06:12:58',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '06:26:58',
    notesSleep: 'dui maecenas tristique est et',
    notesWake: 'libero non mattis pulvinar nulla pede ullamcorper',
  },
  {
    _id: '62a7f19bfc13ae7eb8000045',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-11 21:19:56',
    sleepStart: '2022-03-11 21:19:56',
    sleepEnd: '2022-03-12 08:25:40',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '11:05:44',
    notesSleep: 'at vulputate vitae nisl aenean lectus',
    notesWake: 'sit amet eros suspendisse accumsan tortor quis',
  },
  {
    _id: '62a7f19bfc13ae7eb8000046',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-12 21:26:27',
    sleepStart: '2022-03-12 21:26:27',
    sleepEnd: '2022-03-13 08:22:58',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '09:56:31',
    notesSleep: 'augue vestibulum rutrum rutrum neque aenean auctor gravida',
    notesWake: 'volutpat sapien arcu sed augue aliquam erat volutpat',
  },
  {
    _id: '62a7f19bfc13ae7eb8000047',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-13 23:01:51',
    sleepStart: '2022-03-13 23:01:51',
    sleepEnd: '2022-03-14 08:12:44',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '09:10:53',
    notesSleep: 'pretium iaculis diam erat fermentum justo nec',
    notesWake: 'ac diam cras pellentesque volutpat dui',
  },
  {
    _id: '62a7f19bfc13ae7eb8000048',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-14 22:59:24',
    sleepStart: '2022-03-14 22:59:24',
    sleepEnd: '2022-03-15 08:58:26',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '09:59:02',
    notesSleep: 'augue vestibulum rutrum rutrum neque',
    notesWake: 'urna pretium nisl ut volutpat sapien',
  },
  {
    _id: '62a7f19bfc13ae7eb8000049',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-15 20:23:51',
    sleepStart: '2022-03-15 20:23:51',
    sleepEnd: '2022-03-16 07:11:31',
    moodStart: 1,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '10:47:40',
    notesSleep: 'ante vestibulum ante ipsum primis in',
    notesWake: 'quam sollicitudin vitae consectetuer eget rutrum at',
  },
  {
    _id: '62a7f19bfc13ae7eb800004a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-16 22:47:30',
    sleepStart: '2022-03-16 22:47:30',
    sleepEnd: '2022-03-17 07:37:01',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '08:49:31',
    notesSleep: 'ipsum aliquam non mauris morbi',
    notesWake: 'eros suspendisse accumsan tortor quis turpis sed ante',
  },
  {
    _id: '62a7f19bfc13ae7eb800004b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-17 22:00:16',
    sleepStart: '2022-03-17 22:00:16',
    sleepEnd: '2022-03-18 09:25:07',
    moodStart: 0,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '11:24:51',
    notesSleep: 'massa tempor convallis nulla neque libero convallis',
    notesWake: 'nisl duis bibendum felis sed',
  },
  {
    _id: '62a7f19bfc13ae7eb800004c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-18 22:29:00',
    sleepStart: '2022-03-18 22:29:00',
    sleepEnd: '2022-03-19 06:53:34',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '08:24:34',
    notesSleep: 'praesent blandit lacinia erat vestibulum sed',
    notesWake: 'et ultrices posuere cubilia curae duis faucibus accumsan',
  },
  {
    _id: '62a7f19bfc13ae7eb800004d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-19 21:06:07',
    sleepStart: '2022-03-19 21:06:07',
    sleepEnd: '2022-03-20 06:29:29',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '09:23:22',
    notesSleep: 'dapibus augue vel accumsan tellus nisi eu orci',
    notesWake: 'sem duis aliquam convallis nunc',
  },
  {
    _id: '62a7f19bfc13ae7eb800004e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-20 21:52:01',
    sleepStart: '2022-03-20 21:52:01',
    sleepEnd: '2022-03-21 10:50:53',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '12:58:52',
    notesSleep: 'nulla tempus vivamus in felis eu sapien',
    notesWake: 'sapien varius ut blandit non interdum in',
  },
  {
    _id: '62a7f19bfc13ae7eb800004f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-21 23:52:17',
    sleepStart: '2022-03-21 23:52:17',
    sleepEnd: '2022-03-22 07:25:51',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '07:33:34',
    notesSleep: 'et magnis dis parturient montes',
    notesWake: 'odio justo sollicitudin ut suscipit a feugiat et',
  },
  {
    _id: '62a7f19bfc13ae7eb8000050',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-22 23:25:31',
    sleepStart: '2022-03-22 23:25:31',
    sleepEnd: '2022-03-23 06:20:59',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '06:55:28',
    notesSleep: 'in quam fringilla rhoncus mauris enim leo rhoncus',
    notesWake: 'augue vestibulum rutrum rutrum neque',
  },
  {
    _id: '62a7f19bfc13ae7eb8000051',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-23 22:01:44',
    sleepStart: '2022-03-23 22:01:44',
    sleepEnd: '2022-03-24 09:44:27',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '11:42:43',
    notesSleep: 'praesent blandit lacinia erat vestibulum sed',
    notesWake: 'consequat lectus in est risus auctor sed tristique',
  },
  {
    _id: '62a7f19bfc13ae7eb8000052',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-24 21:54:31',
    sleepStart: '2022-03-24 21:54:31',
    sleepEnd: '2022-03-25 10:59:59',
    moodStart: 1,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '13:05:28',
    notesSleep: 'nulla nisl nunc nisl duis bibendum felis sed',
    notesWake: 'amet erat nulla tempus vivamus in',
  },
  {
    _id: '62a7f19bfc13ae7eb8000053',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-25 23:16:41',
    sleepStart: '2022-03-25 23:16:41',
    sleepEnd: '2022-03-26 10:52:00',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '11:35:19',
    notesSleep: 'ornare consequat lectus in est',
    notesWake: 'integer aliquet massa id lobortis convallis',
  },
  {
    _id: '62a7f19bfc13ae7eb8000054',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-26 21:22:26',
    sleepStart: '2022-03-26 21:22:26',
    sleepEnd: '2022-03-27 06:37:01',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '09:14:35',
    notesSleep: 'cras mi pede malesuada in imperdiet',
    notesWake: 'et eros vestibulum ac est lacinia',
  },
  {
    _id: '62a7f19bfc13ae7eb8000055',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-27 22:23:45',
    sleepStart: '2022-03-27 22:23:45',
    sleepEnd: '2022-03-28 08:27:52',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '10:04:07',
    notesSleep: 'consequat varius integer ac leo pellentesque ultrices',
    notesWake: 'dapibus duis at velit eu',
  },
  {
    _id: '62a7f19bfc13ae7eb8000056',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-28 21:29:21',
    sleepStart: '2022-03-28 21:29:21',
    sleepEnd: '2022-03-29 06:11:41',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '08:42:20',
    notesSleep: 'velit nec nisi vulputate nonummy maecenas',
    notesWake: 'elementum pellentesque quisque porta volutpat erat quisque',
  },
  {
    _id: '62a7f19bfc13ae7eb8000057',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-29 23:30:55',
    sleepStart: '2022-03-29 23:30:55',
    sleepEnd: '2022-03-30 10:49:48',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '11:18:53',
    notesSleep: 'et ultrices posuere cubilia curae mauris viverra',
    notesWake: 'sit amet cursus id turpis',
  },
  {
    _id: '62a7f19bfc13ae7eb8000058',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-30 22:23:48',
    sleepStart: '2022-03-30 22:23:48',
    sleepEnd: '2022-03-31 10:02:12',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '11:38:24',
    notesSleep: 'sapien sapien non mi integer ac neque duis',
    notesWake: 'etiam vel augue vestibulum rutrum rutrum neque aenean',
  },
  {
    _id: '62a7f19bfc13ae7eb8000059',
    creator: '623300e3f0323969f1010b28',
    date: '2022-03-31 21:52:18',
    sleepStart: '2022-03-31 21:52:18',
    sleepEnd: '2022-04-01 06:00:37',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '08:08:19',
    notesSleep: 'velit id pretium iaculis diam',
    notesWake: 'ut volutpat sapien arcu sed augue aliquam',
  },
  {
    _id: '62a7f19bfc13ae7eb800005a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-01 22:28:23',
    sleepStart: '2022-04-01 22:28:23',
    sleepEnd: '2022-04-02 06:10:31',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '07:42:08',
    notesSleep: 'fusce posuere felis sed lacus morbi sem mauris',
    notesWake: 'praesent lectus vestibulum quam sapien varius ut',
  },
  {
    _id: '62a7f19bfc13ae7eb800005b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-02 20:32:38',
    sleepStart: '2022-04-02 20:32:38',
    sleepEnd: '2022-04-03 09:50:03',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '13:17:25',
    notesSleep: 'metus aenean fermentum donec ut mauris eget massa',
    notesWake: 'aenean auctor gravida sem praesent id massa id',
  },
  {
    _id: '62a7f19bfc13ae7eb800005c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-03 20:34:23',
    sleepStart: '2022-04-03 20:34:23',
    sleepEnd: '2022-04-04 06:35:34',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '10:01:11',
    notesSleep: 'purus phasellus in felis donec semper',
    notesWake: 'odio curabitur convallis duis consequat',
  },
  {
    _id: '62a7f19bfc13ae7eb800005d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-04 23:08:08',
    sleepStart: '2022-04-04 23:08:08',
    sleepEnd: '2022-04-05 08:49:57',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '09:41:49',
    notesSleep: 'orci nullam molestie nibh in',
    notesWake: 'laoreet ut rhoncus aliquet pulvinar sed nisl nunc',
  },
  {
    _id: '62a7f19bfc13ae7eb800005e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-05 20:36:31',
    sleepStart: '2022-04-05 20:36:31',
    sleepEnd: '2022-04-06 09:02:55',
    moodStart: 1,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '12:26:24',
    notesSleep: 'est quam pharetra magna ac consequat metus sapien',
    notesWake: 'mattis odio donec vitae nisi nam ultrices',
  },
  {
    _id: '62a7f19bfc13ae7eb800005f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-06 22:27:33',
    sleepStart: '2022-04-06 22:27:33',
    sleepEnd: '2022-04-07 09:04:35',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '10:37:02',
    notesSleep: 'risus praesent lectus vestibulum quam sapien varius ut',
    notesWake: 'arcu adipiscing molestie hendrerit at vulputate vitae',
  },
  {
    _id: '62a7f19cfc13ae7eb8000060',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-07 21:18:02',
    sleepStart: '2022-04-07 21:18:02',
    sleepEnd: '2022-04-08 09:15:14',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '11:57:12',
    notesSleep: 'vehicula condimentum curabitur in libero ut massa',
    notesWake: 'erat tortor sollicitudin mi sit amet lobortis sapien',
  },
  {
    _id: '62a7f19cfc13ae7eb8000061',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-08 23:41:08',
    sleepStart: '2022-04-08 23:41:08',
    sleepEnd: '2022-04-09 09:34:12',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '09:53:04',
    notesSleep: 'vel est donec odio justo sollicitudin',
    notesWake: 'enim sit amet nunc viverra dapibus',
  },
  {
    _id: '62a7f19cfc13ae7eb8000062',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-09 20:42:41',
    sleepStart: '2022-04-09 20:42:41',
    sleepEnd: '2022-04-10 10:25:30',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '13:42:49',
    notesSleep: 'lobortis est phasellus sit amet erat nulla',
    notesWake: 'vulputate luctus cum sociis natoque penatibus',
  },
  {
    _id: '62a7f19cfc13ae7eb8000063',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-10 21:29:12',
    sleepStart: '2022-04-10 21:29:12',
    sleepEnd: '2022-04-11 09:36:39',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '12:07:27',
    notesSleep: 'placerat praesent blandit nam nulla integer pede',
    notesWake: 'aenean lectus pellentesque eget nunc donec',
  },
  {
    _id: '62a7f19cfc13ae7eb8000064',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-11 22:23:35',
    sleepStart: '2022-04-11 22:23:35',
    sleepEnd: '2022-04-12 07:58:11',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '09:34:36',
    notesSleep: 'mi integer ac neque duis bibendum morbi',
    notesWake: 'in sagittis dui vel nisl duis ac',
  },
  {
    _id: '62a7f19cfc13ae7eb8000065',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-12 21:45:46',
    sleepStart: '2022-04-12 21:45:46',
    sleepEnd: '2022-04-13 09:42:59',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '11:57:13',
    notesSleep: 'ullamcorper augue a suscipit nulla',
    notesWake: 'ac leo pellentesque ultrices mattis',
  },
  {
    _id: '62a7f19cfc13ae7eb8000066',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-13 21:35:50',
    sleepStart: '2022-04-13 21:35:50',
    sleepEnd: '2022-04-14 10:49:09',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '13:13:19',
    notesSleep: 'habitasse platea dictumst morbi vestibulum velit id',
    notesWake: 'donec semper sapien a libero',
  },
  {
    _id: '62a7f19cfc13ae7eb8000067',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-14 23:19:28',
    sleepStart: '2022-04-14 23:19:28',
    sleepEnd: '2022-04-15 07:49:28',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '08:30:00',
    notesSleep: 'lacus at velit vivamus vel nulla',
    notesWake: 'tincidunt nulla mollis molestie lorem',
  },
  {
    _id: '62a7f19cfc13ae7eb8000068',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-15 20:48:54',
    sleepStart: '2022-04-15 20:48:54',
    sleepEnd: '2022-04-16 09:57:09',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '13:08:15',
    notesSleep: 'maecenas rhoncus aliquam lacus morbi quis tortor id',
    notesWake: 'in hac habitasse platea dictumst',
  },
  {
    _id: '62a7f19cfc13ae7eb8000069',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-16 20:23:54',
    sleepStart: '2022-04-16 20:23:54',
    sleepEnd: '2022-04-17 08:03:34',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '11:39:40',
    notesSleep: 'vulputate elementum nullam varius nulla facilisi cras',
    notesWake: 'varius nulla facilisi cras non velit nec',
  },
  {
    _id: '62a7f19cfc13ae7eb800006a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-17 21:48:29',
    sleepStart: '2022-04-17 21:48:29',
    sleepEnd: '2022-04-18 07:20:07',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '09:31:38',
    notesSleep: 'lectus in est risus auctor sed',
    notesWake: 'iaculis justo in hac habitasse platea dictumst etiam',
  },
  {
    _id: '62a7f19cfc13ae7eb800006b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-18 22:19:09',
    sleepStart: '2022-04-18 22:19:09',
    sleepEnd: '2022-04-19 07:34:31',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '09:15:22',
    notesSleep: 'tortor sollicitudin mi sit amet lobortis sapien',
    notesWake: 'sed lacus morbi sem mauris',
  },
  {
    _id: '62a7f19cfc13ae7eb800006c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-19 20:59:46',
    sleepStart: '2022-04-19 20:59:46',
    sleepEnd: '2022-04-20 07:31:22',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '10:31:36',
    notesSleep: 'morbi non lectus aliquam sit',
    notesWake: 'ullamcorper purus sit amet nulla quisque arcu',
  },
  {
    _id: '62a7f19cfc13ae7eb800006d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-20 21:26:53',
    sleepStart: '2022-04-20 21:26:53',
    sleepEnd: '2022-04-21 07:19:55',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '09:53:02',
    notesSleep: 'quam pharetra magna ac consequat metus sapien ut',
    notesWake: 'dui proin leo odio porttitor id',
  },
  {
    _id: '62a7f19cfc13ae7eb800006e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-21 21:08:22',
    sleepStart: '2022-04-21 21:08:22',
    sleepEnd: '2022-04-22 08:41:33',
    moodStart: 3,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '11:33:11',
    notesSleep: 'neque libero convallis eget eleifend',
    notesWake: 'nam nulla integer pede justo lacinia eget',
  },
  {
    _id: '62a7f19cfc13ae7eb800006f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-22 23:08:26',
    sleepStart: '2022-04-22 23:08:26',
    sleepEnd: '2022-04-23 09:45:14',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '10:36:48',
    notesSleep: 'primis in faucibus orci luctus et ultrices',
    notesWake: 'volutpat erat quisque erat eros viverra eget',
  },
  {
    _id: '62a7f19cfc13ae7eb8000070',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-23 22:56:15',
    sleepStart: '2022-04-23 22:56:15',
    sleepEnd: '2022-04-24 06:53:47',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '07:57:32',
    notesSleep: 'vestibulum aliquet ultrices erat tortor',
    notesWake: 'interdum mauris ullamcorper purus sit amet nulla',
  },
  {
    _id: '62a7f19cfc13ae7eb8000071',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-24 21:54:50',
    sleepStart: '2022-04-24 21:54:50',
    sleepEnd: '2022-04-25 08:38:26',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '10:43:36',
    notesSleep: 'vestibulum eget vulputate ut ultrices',
    notesWake: 'ac lobortis vel dapibus at',
  },
  {
    _id: '62a7f19cfc13ae7eb8000072',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-25 21:44:08',
    sleepStart: '2022-04-25 21:44:08',
    sleepEnd: '2022-04-26 06:31:26',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '08:47:18',
    notesSleep: 'cubilia curae duis faucibus accumsan odio',
    notesWake: 'quam pharetra magna ac consequat metus',
  },
  {
    _id: '62a7f19cfc13ae7eb8000073',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-26 21:03:03',
    sleepStart: '2022-04-26 21:03:03',
    sleepEnd: '2022-04-27 09:31:31',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '12:28:28',
    notesSleep: 'vestibulum ac est lacinia nisi',
    notesWake: 'libero non mattis pulvinar nulla pede ullamcorper',
  },
  {
    _id: '62a7f19cfc13ae7eb8000074',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-27 23:28:44',
    sleepStart: '2022-04-27 23:28:44',
    sleepEnd: '2022-04-28 08:19:13',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '08:50:29',
    notesSleep: 'morbi sem mauris laoreet ut',
    notesWake: 'sociis natoque penatibus et magnis dis parturient',
  },
  {
    _id: '62a7f19cfc13ae7eb8000075',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-28 22:12:21',
    sleepStart: '2022-04-28 22:12:21',
    sleepEnd: '2022-04-29 06:58:40',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '08:46:19',
    notesSleep: 'etiam faucibus cursus urna ut',
    notesWake: 'ut rhoncus aliquet pulvinar sed nisl',
  },
  {
    _id: '62a7f19cfc13ae7eb8000076',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-29 22:05:23',
    sleepStart: '2022-04-29 22:05:23',
    sleepEnd: '2022-04-30 06:35:12',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '08:29:49',
    notesSleep: 'faucibus cursus urna ut tellus nulla ut',
    notesWake: 'felis eu sapien cursus vestibulum proin',
  },
  {
    _id: '62a7f19cfc13ae7eb8000077',
    creator: '623300e3f0323969f1010b28',
    date: '2022-04-30 22:37:44',
    sleepStart: '2022-04-30 22:37:44',
    sleepEnd: '2022-05-01 09:53:17',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '11:15:33',
    notesSleep: 'semper est quam pharetra magna',
    notesWake: 'libero nam dui proin leo odio porttitor id',
  },
  {
    _id: '62a7f19cfc13ae7eb8000078',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-01 20:20:44',
    sleepStart: '2022-05-01 20:20:44',
    sleepEnd: '2022-05-02 07:37:54',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '11:17:10',
    notesSleep: 'at vulputate vitae nisl aenean lectus',
    notesWake: 'in hac habitasse platea dictumst',
  },
  {
    _id: '62a7f19cfc13ae7eb8000079',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-02 22:08:57',
    sleepStart: '2022-05-02 22:08:57',
    sleepEnd: '2022-05-03 06:37:25',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '08:28:28',
    notesSleep: 'faucibus orci luctus et ultrices posuere cubilia curae',
    notesWake: 'faucibus accumsan odio curabitur convallis',
  },
  {
    _id: '62a7f19cfc13ae7eb800007a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-03 23:16:30',
    sleepStart: '2022-05-03 23:16:30',
    sleepEnd: '2022-05-04 06:37:02',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '07:20:32',
    notesSleep: 'ipsum dolor sit amet consectetuer adipiscing elit proin',
    notesWake: 'vestibulum rutrum rutrum neque aenean auctor',
  },
  {
    _id: '62a7f19cfc13ae7eb800007b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-04 22:58:14',
    sleepStart: '2022-05-04 22:58:14',
    sleepEnd: '2022-05-05 08:42:28',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '09:44:14',
    notesSleep: 'nulla justo aliquam quis turpis eget',
    notesWake: 'leo odio porttitor id consequat in',
  },
  {
    _id: '62a7f19cfc13ae7eb800007c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-05 21:27:01',
    sleepStart: '2022-05-05 21:27:01',
    sleepEnd: '2022-05-06 06:14:34',
    moodStart: 0,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '08:47:33',
    notesSleep: 'accumsan tellus nisi eu orci mauris lacinia sapien',
    notesWake: 'quis lectus suspendisse potenti in eleifend quam a',
  },
  {
    _id: '62a7f19cfc13ae7eb800007d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-06 21:22:53',
    sleepStart: '2022-05-06 21:22:53',
    sleepEnd: '2022-05-07 09:14:30',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '11:51:37',
    notesSleep: 'erat tortor sollicitudin mi sit amet lobortis',
    notesWake: 'leo rhoncus sed vestibulum sit',
  },
  {
    _id: '62a7f19cfc13ae7eb800007e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-07 22:00:17',
    sleepStart: '2022-05-07 22:00:17',
    sleepEnd: '2022-05-08 08:31:54',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '10:31:37',
    notesSleep: 'urna pretium nisl ut volutpat sapien',
    notesWake: 'suspendisse potenti nullam porttitor lacus at turpis',
  },
  {
    _id: '62a7f19cfc13ae7eb800007f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-08 22:32:23',
    sleepStart: '2022-05-08 22:32:23',
    sleepEnd: '2022-05-09 09:15:06',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '10:42:43',
    notesSleep: 'id sapien in sapien iaculis congue vivamus metus',
    notesWake: 'vestibulum ante ipsum primis in faucibus',
  },
  {
    _id: '62a7f19cfc13ae7eb8000080',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-09 20:54:50',
    sleepStart: '2022-05-09 20:54:50',
    sleepEnd: '2022-05-10 06:36:10',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '09:41:20',
    notesSleep: 'habitasse platea dictumst etiam faucibus cursus',
    notesWake: 'diam cras pellentesque volutpat dui maecenas',
  },
  {
    _id: '62a7f19cfc13ae7eb8000081',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-10 22:23:13',
    sleepStart: '2022-05-10 22:23:13',
    sleepEnd: '2022-05-11 10:19:34',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '11:56:21',
    notesSleep: 'vestibulum eget vulputate ut ultrices',
    notesWake: 'dui vel nisl duis ac nibh fusce',
  },
  {
    _id: '62a7f19cfc13ae7eb8000082',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-11 23:49:23',
    sleepStart: '2022-05-11 23:49:23',
    sleepEnd: '2022-05-12 10:27:41',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '10:38:18',
    notesSleep: 'aliquam sit amet diam in magna',
    notesWake: 'felis sed lacus morbi sem mauris',
  },
  {
    _id: '62a7f19cfc13ae7eb8000083',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-12 23:36:25',
    sleepStart: '2022-05-12 23:36:25',
    sleepEnd: '2022-05-13 10:46:32',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '11:10:07',
    notesSleep: 'amet diam in magna bibendum imperdiet nullam',
    notesWake: 'aliquam convallis nunc proin at turpis a pede',
  },
  {
    _id: '62a7f19cfc13ae7eb8000084',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-13 21:24:02',
    sleepStart: '2022-05-13 21:24:02',
    sleepEnd: '2022-05-14 06:50:49',
    moodStart: 2,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '09:26:47',
    notesSleep: 'in tempus sit amet sem fusce consequat nulla',
    notesWake: 'viverra dapibus nulla suscipit ligula',
  },
  {
    _id: '62a7f19cfc13ae7eb8000085',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-14 22:35:08',
    sleepStart: '2022-05-14 22:35:08',
    sleepEnd: '2022-05-15 06:43:50',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '08:08:42',
    notesSleep: 'mi in porttitor pede justo eu massa donec',
    notesWake: 'congue vivamus metus arcu adipiscing',
  },
  {
    _id: '62a7f19cfc13ae7eb8000086',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-15 20:48:01',
    sleepStart: '2022-05-15 20:48:01',
    sleepEnd: '2022-05-16 09:34:26',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '12:46:25',
    notesSleep: 'porta volutpat erat quisque erat eros',
    notesWake: 'velit nec nisi vulputate nonummy maecenas tincidunt lacus',
  },
  {
    _id: '62a7f19cfc13ae7eb8000087',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-16 21:27:26',
    sleepStart: '2022-05-16 21:27:26',
    sleepEnd: '2022-05-17 07:24:56',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '09:57:30',
    notesSleep: 'lectus pellentesque eget nunc donec quis',
    notesWake: 'magna vulputate luctus cum sociis natoque',
  },
  {
    _id: '62a7f19cfc13ae7eb8000088',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-17 22:06:37',
    sleepStart: '2022-05-17 22:06:37',
    sleepEnd: '2022-05-18 06:01:18',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '07:54:41',
    notesSleep: 'augue a suscipit nulla elit ac nulla sed',
    notesWake: 'vel enim sit amet nunc',
  },
  {
    _id: '62a7f19cfc13ae7eb8000089',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-18 21:46:34',
    sleepStart: '2022-05-18 21:46:34',
    sleepEnd: '2022-05-19 06:12:30',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '08:25:56',
    notesSleep: 'sit amet justo morbi ut odio',
    notesWake: 'dapibus duis at velit eu',
  },
  {
    _id: '62a7f19cfc13ae7eb800008a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-19 20:56:00',
    sleepStart: '2022-05-19 20:56:00',
    sleepEnd: '2022-05-20 08:27:43',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '11:31:43',
    notesSleep: 'ante ipsum primis in faucibus',
    notesWake: 'proin at turpis a pede posuere',
  },
  {
    _id: '62a7f19cfc13ae7eb800008b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-20 20:13:52',
    sleepStart: '2022-05-20 20:13:52',
    sleepEnd: '2022-05-21 06:45:51',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '10:31:59',
    notesSleep: 'nunc commodo placerat praesent blandit nam',
    notesWake: 'amet nulla quisque arcu libero',
  },
  {
    _id: '62a7f19cfc13ae7eb800008c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-21 21:45:10',
    sleepStart: '2022-05-21 21:45:10',
    sleepEnd: '2022-05-22 10:14:23',
    moodStart: 0,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '12:29:13',
    notesSleep: 'ac nibh fusce lacus purus aliquet at feugiat',
    notesWake: 'aenean lectus pellentesque eget nunc donec quis orci',
  },
  {
    _id: '62a7f19cfc13ae7eb800008d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-22 20:08:10',
    sleepStart: '2022-05-22 20:08:10',
    sleepEnd: '2022-05-23 10:45:14',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '14:37:04',
    notesSleep: 'potenti nullam porttitor lacus at',
    notesWake: 'libero ut massa volutpat convallis morbi odio odio',
  },
  {
    _id: '62a7f19cfc13ae7eb800008e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-23 22:53:11',
    sleepStart: '2022-05-23 22:53:11',
    sleepEnd: '2022-05-24 10:55:06',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '12:01:55',
    notesSleep: 'donec ut mauris eget massa tempor convallis',
    notesWake: 'dapibus nulla suscipit ligula in',
  },
  {
    _id: '62a7f19cfc13ae7eb800008f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-24 20:26:23',
    sleepStart: '2022-05-24 20:26:23',
    sleepEnd: '2022-05-25 07:18:01',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '10:51:38',
    notesSleep:
      'proin interdum mauris non ligula pellentesque ultrices phasellus',
    notesWake: 'est congue elementum in hac',
  },
  {
    _id: '62a7f19cfc13ae7eb8000090',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-25 21:30:53',
    sleepStart: '2022-05-25 21:30:53',
    sleepEnd: '2022-05-26 08:40:05',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '11:09:12',
    notesSleep: 'pretium iaculis justo in hac habitasse platea',
    notesWake: 'volutpat erat quisque erat eros viverra eget congue',
  },
  {
    _id: '62a7f19cfc13ae7eb8000091',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-26 20:36:06',
    sleepStart: '2022-05-26 20:36:06',
    sleepEnd: '2022-05-27 08:46:06',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '12:10:00',
    notesSleep: 'nulla pede ullamcorper augue a',
    notesWake: 'parturient montes nascetur ridiculus mus etiam vel',
  },
  {
    _id: '62a7f19cfc13ae7eb8000092',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-27 20:17:21',
    sleepStart: '2022-05-27 20:17:21',
    sleepEnd: '2022-05-28 08:45:58',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '12:28:37',
    notesSleep: 'vestibulum ante ipsum primis in',
    notesWake: 'quis odio consequat varius integer ac',
  },
  {
    _id: '62a7f19cfc13ae7eb8000093',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-28 23:16:41',
    sleepStart: '2022-05-28 23:16:41',
    sleepEnd: '2022-05-29 10:01:45',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '10:45:04',
    notesSleep: 'donec ut mauris eget massa',
    notesWake: 'at dolor quis odio consequat varius',
  },
  {
    _id: '62a7f19cfc13ae7eb8000094',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-29 21:00:56',
    sleepStart: '2022-05-29 21:00:56',
    sleepEnd: '2022-05-30 10:49:44',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '13:48:48',
    notesSleep: 'nunc purus phasellus in felis donec',
    notesWake: 'id consequat in consequat ut nulla',
  },
  {
    _id: '62a7f19cfc13ae7eb8000095',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-30 20:47:51',
    sleepStart: '2022-05-30 20:47:51',
    sleepEnd: '2022-05-31 08:51:53',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '12:04:02',
    notesSleep: 'maecenas rhoncus aliquam lacus morbi quis tortor',
    notesWake: 'diam in magna bibendum imperdiet nullam orci pede',
  },
  {
    _id: '62a7f19cfc13ae7eb8000096',
    creator: '623300e3f0323969f1010b28',
    date: '2022-05-31 20:43:13',
    sleepStart: '2022-05-31 20:43:13',
    sleepEnd: '2022-06-01 06:25:22',
    moodStart: 1,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '09:42:09',
    notesSleep: 'turpis a pede posuere nonummy integer',
    notesWake: 'sollicitudin ut suscipit a feugiat et eros',
  },
  {
    _id: '62a7f19cfc13ae7eb8000097',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-01 22:51:16',
    sleepStart: '2022-06-01 22:51:16',
    sleepEnd: '2022-06-02 06:06:58',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '07:15:42',
    notesSleep: 'platea dictumst morbi vestibulum velit id pretium',
    notesWake: 'pede libero quis orci nullam molestie nibh',
  },
  {
    _id: '62a7f19cfc13ae7eb8000098',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-02 21:04:45',
    sleepStart: '2022-06-02 21:04:45',
    sleepEnd: '2022-06-03 07:17:56',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '10:13:11',
    notesSleep: 'at lorem integer tincidunt ante vel ipsum',
    notesWake: 'odio justo sollicitudin ut suscipit a feugiat et',
  },
  {
    _id: '62a7f19cfc13ae7eb8000099',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-03 23:41:50',
    sleepStart: '2022-06-03 23:41:50',
    sleepEnd: '2022-06-04 08:36:22',
    moodStart: 0,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '08:54:32',
    notesSleep: 'hac habitasse platea dictumst morbi vestibulum velit id',
    notesWake: 'curabitur gravida nisi at nibh in hac habitasse',
  },
  {
    _id: '62a7f19cfc13ae7eb800009a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-04 23:05:14',
    sleepStart: '2022-06-04 23:05:14',
    sleepEnd: '2022-06-05 06:00:24',
    moodStart: 1,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '06:55:10',
    notesSleep: 'luctus et ultrices posuere cubilia',
    notesWake: 'quis justo maecenas rhoncus aliquam lacus morbi',
  },
  {
    _id: '62a7f19cfc13ae7eb800009b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-05 23:50:52',
    sleepStart: '2022-06-05 23:50:52',
    sleepEnd: '2022-06-06 10:21:17',
    moodStart: 0,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '10:30:25',
    notesSleep: 'non lectus aliquam sit amet diam in magna',
    notesWake: 'curabitur in libero ut massa volutpat',
  },
  {
    _id: '62a7f19cfc13ae7eb800009c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-06 23:14:40',
    sleepStart: '2022-06-06 23:14:40',
    sleepEnd: '2022-06-07 09:10:13',
    moodStart: 3,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '09:55:33',
    notesSleep: 'non velit donec diam neque',
    notesWake: 'pede ullamcorper augue a suscipit nulla elit',
  },
  {
    _id: '62a7f19cfc13ae7eb800009d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-07 21:14:56',
    sleepStart: '2022-06-07 21:14:56',
    sleepEnd: '2022-06-08 07:23:05',
    moodStart: 1,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '10:08:09',
    notesSleep: 'in felis donec semper sapien a libero',
    notesWake: 'purus eu magna vulputate luctus cum sociis',
  },
  {
    _id: '62a7f19cfc13ae7eb800009e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-08 21:27:09',
    sleepStart: '2022-06-08 21:27:09',
    sleepEnd: '2022-06-09 07:51:13',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '10:24:04',
    notesSleep: 'lacus purus aliquet at feugiat non',
    notesWake: 'eu est congue elementum in',
  },
  {
    _id: '62a7f19cfc13ae7eb800009f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-09 20:29:36',
    sleepStart: '2022-06-09 20:29:36',
    sleepEnd: '2022-06-10 07:37:25',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '11:07:49',
    notesSleep: 'ante ipsum primis in faucibus',
    notesWake: 'ligula vehicula consequat morbi a ipsum integer',
  },
  {
    _id: '62a7f19cfc13ae7eb80000a0',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-10 21:05:02',
    sleepStart: '2022-06-10 21:05:02',
    sleepEnd: '2022-06-11 09:54:53',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '12:49:51',
    notesSleep: 'vitae nisi nam ultrices libero non',
    notesWake: 'est phasellus sit amet erat nulla tempus vivamus',
  },
  {
    _id: '62a7f19cfc13ae7eb80000a1',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-11 21:17:03',
    sleepStart: '2022-06-11 21:17:03',
    sleepEnd: '2022-06-12 07:48:24',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '10:31:21',
    notesSleep: 'posuere cubilia curae nulla dapibus dolor vel',
    notesWake: 'nisl venenatis lacinia aenean sit amet justo morbi',
  },
  {
    _id: '62a7f19cfc13ae7eb80000a2',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-12 21:37:20',
    sleepStart: '2022-06-12 21:37:20',
    sleepEnd: '2022-06-13 10:18:56',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '12:41:36',
    notesSleep: 'erat nulla tempus vivamus in felis eu',
    notesWake: 'blandit mi in porttitor pede justo',
  },
  {
    _id: '62a7f19cfc13ae7eb80000a3',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-13 22:04:42',
    sleepStart: '2022-06-13 22:04:42',
    sleepEnd: '2022-06-14 08:27:16',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '10:22:34',
    notesSleep: 'ante ipsum primis in faucibus orci luctus et',
    notesWake: 'congue eget semper rutrum nulla nunc purus',
  },
  {
    _id: '62a7f19cfc13ae7eb80000a4',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-14 21:35:16',
    sleepStart: '2022-06-14 21:35:16',
    sleepEnd: '2022-06-15 06:14:40',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '08:39:24',
    notesSleep: 'nisl nunc nisl duis bibendum felis sed interdum',
    notesWake: 'ut odio cras mi pede',
  },
  {
    _id: '62a7f19cfc13ae7eb80000a5',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-15 23:06:35',
    sleepStart: '2022-06-15 23:06:35',
    sleepEnd: '2022-06-16 10:09:50',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '11:03:15',
    notesSleep: 'euismod scelerisque quam turpis adipiscing lorem vitae mattis',
    notesWake: 'tincidunt eu felis fusce posuere felis sed',
  },
  {
    _id: '62a7f19cfc13ae7eb80000a6',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-16 22:27:33',
    sleepStart: '2022-06-16 22:27:33',
    sleepEnd: '2022-06-17 07:11:48',
    moodStart: 0,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '08:44:15',
    notesSleep: 'potenti cras in purus eu magna',
    notesWake: 'dui vel sem sed sagittis nam congue',
  },
  {
    _id: '62a7f19cfc13ae7eb80000a7',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-17 21:22:17',
    sleepStart: '2022-06-17 21:22:17',
    sleepEnd: '2022-06-18 06:02:15',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '08:39:58',
    notesSleep: 'morbi odio odio elementum eu interdum',
    notesWake: 'cras non velit nec nisi vulputate',
  },
  {
    _id: '62a7f19cfc13ae7eb80000a8',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-18 23:47:18',
    sleepStart: '2022-06-18 23:47:18',
    sleepEnd: '2022-06-19 10:01:40',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '10:14:22',
    notesSleep: 'vel dapibus at diam nam tristique tortor eu',
    notesWake: 'volutpat quam pede lobortis ligula',
  },
  {
    _id: '62a7f19cfc13ae7eb80000a9',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-19 20:41:59',
    sleepStart: '2022-06-19 20:41:59',
    sleepEnd: '2022-06-20 06:22:33',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '09:40:34',
    notesSleep: 'quam suspendisse potenti nullam porttitor lacus',
    notesWake: 'dictumst aliquam augue quam sollicitudin vitae',
  },
  {
    _id: '62a7f19cfc13ae7eb80000aa',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-20 20:07:04',
    sleepStart: '2022-06-20 20:07:04',
    sleepEnd: '2022-06-21 09:29:31',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '13:22:27',
    notesSleep: 'pellentesque viverra pede ac diam cras pellentesque',
    notesWake: 'in porttitor pede justo eu massa',
  },
  {
    _id: '62a7f19cfc13ae7eb80000ab',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-21 23:50:43',
    sleepStart: '2022-06-21 23:50:43',
    sleepEnd: '2022-06-22 06:46:57',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '06:56:14',
    notesSleep: 'in quis justo maecenas rhoncus',
    notesWake: 'aliquet at feugiat non pretium',
  },
  {
    _id: '62a7f19cfc13ae7eb80000ac',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-22 22:28:13',
    sleepStart: '2022-06-22 22:28:13',
    sleepEnd: '2022-06-23 07:36:36',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '09:08:23',
    notesSleep: 'mus etiam vel augue vestibulum rutrum rutrum',
    notesWake: 'lorem integer tincidunt ante vel ipsum',
  },
  {
    _id: '62a7f19cfc13ae7eb80000ad',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-23 20:52:19',
    sleepStart: '2022-06-23 20:52:19',
    sleepEnd: '2022-06-24 07:58:43',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '11:06:24',
    notesSleep: 'platea dictumst maecenas ut massa quis augue luctus',
    notesWake: 'congue elementum in hac habitasse',
  },
  {
    _id: '62a7f19cfc13ae7eb80000ae',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-24 23:58:20',
    sleepStart: '2022-06-24 23:58:20',
    sleepEnd: '2022-06-25 07:50:00',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '07:51:40',
    notesSleep: 'in sagittis dui vel nisl duis ac nibh',
    notesWake: 'elit proin interdum mauris non',
  },
  {
    _id: '62a7f19cfc13ae7eb80000af',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-25 23:10:47',
    sleepStart: '2022-06-25 23:10:47',
    sleepEnd: '2022-06-26 07:28:41',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '08:17:54',
    notesSleep: 'non sodales sed tincidunt eu felis fusce',
    notesWake: 'sapien arcu sed augue aliquam erat volutpat in',
  },
  {
    _id: '62a7f19cfc13ae7eb80000b0',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-26 22:44:49',
    sleepStart: '2022-06-26 22:44:49',
    sleepEnd: '2022-06-27 10:19:06',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '11:34:17',
    notesSleep: 'bibendum imperdiet nullam orci pede venenatis non sodales',
    notesWake: 'magna at nunc commodo placerat praesent blandit nam',
  },
  {
    _id: '62a7f19cfc13ae7eb80000b1',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-27 22:54:58',
    sleepStart: '2022-06-27 22:54:58',
    sleepEnd: '2022-06-28 10:52:22',
    moodStart: 0,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '11:57:24',
    notesSleep: 'in tempus sit amet sem fusce consequat',
    notesWake: 'odio consequat varius integer ac leo',
  },
  {
    _id: '62a7f19cfc13ae7eb80000b2',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-28 23:50:58',
    sleepStart: '2022-06-28 23:50:58',
    sleepEnd: '2022-06-29 08:37:58',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '08:47:00',
    notesSleep: 'luctus nec molestie sed justo pellentesque',
    notesWake: 'aliquet massa id lobortis convallis',
  },
  {
    _id: '62a7f19cfc13ae7eb80000b3',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-29 22:44:51',
    sleepStart: '2022-06-29 22:44:51',
    sleepEnd: '2022-06-30 09:50:19',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '11:05:28',
    notesSleep: 'semper sapien a libero nam',
    notesWake: 'convallis tortor risus dapibus augue vel accumsan',
  },
  {
    _id: '62a7f19cfc13ae7eb80000b4',
    creator: '623300e3f0323969f1010b28',
    date: '2022-06-30 21:47:39',
    sleepStart: '2022-06-30 21:47:39',
    sleepEnd: '2022-07-01 06:55:45',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '09:08:06',
    notesSleep: 'curae nulla dapibus dolor vel est donec',
    notesWake: 'vestibulum sed magna at nunc',
  },
  {
    _id: '62a7f19cfc13ae7eb80000b5',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-01 22:14:57',
    sleepStart: '2022-07-01 22:14:57',
    sleepEnd: '2022-07-02 09:22:05',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '11:07:08',
    notesSleep: 'lectus in est risus auctor',
    notesWake: 'vestibulum ante ipsum primis in faucibus orci',
  },
  {
    _id: '62a7f19cfc13ae7eb80000b6',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-02 21:27:57',
    sleepStart: '2022-07-02 21:27:57',
    sleepEnd: '2022-07-03 06:03:59',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '08:36:02',
    notesSleep: 'erat vestibulum sed magna at nunc',
    notesWake: 'elementum nullam varius nulla facilisi cras non velit',
  },
  {
    _id: '62a7f19cfc13ae7eb80000b7',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-03 20:04:09',
    sleepStart: '2022-07-03 20:04:09',
    sleepEnd: '2022-07-04 08:54:15',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '12:50:06',
    notesSleep: 'vel sem sed sagittis nam congue risus',
    notesWake: 'eleifend quam a odio in',
  },
  {
    _id: '62a7f19cfc13ae7eb80000b8',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-04 21:08:44',
    sleepStart: '2022-07-04 21:08:44',
    sleepEnd: '2022-07-05 06:53:45',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '09:45:01',
    notesSleep: 'vestibulum velit id pretium iaculis diam',
    notesWake: 'ridiculus mus vivamus vestibulum sagittis',
  },
  {
    _id: '62a7f19cfc13ae7eb80000b9',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-05 20:07:05',
    sleepStart: '2022-07-05 20:07:05',
    sleepEnd: '2022-07-06 09:57:39',
    moodStart: 2,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '13:50:34',
    notesSleep: 'phasellus in felis donec semper sapien',
    notesWake: 'dui maecenas tristique est et tempus',
  },
  {
    _id: '62a7f19cfc13ae7eb80000ba',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-06 21:23:10',
    sleepStart: '2022-07-06 21:23:10',
    sleepEnd: '2022-07-07 08:46:46',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '11:23:36',
    notesSleep: 'eget eleifend luctus ultricies eu',
    notesWake: 'turpis enim blandit mi in porttitor',
  },
  {
    _id: '62a7f19cfc13ae7eb80000bb',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-07 23:46:44',
    sleepStart: '2022-07-07 23:46:44',
    sleepEnd: '2022-07-08 06:51:47',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '07:05:03',
    notesSleep: 'cum sociis natoque penatibus et magnis dis parturient',
    notesWake: 'porttitor lacus at turpis donec',
  },
  {
    _id: '62a7f19cfc13ae7eb80000bc',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-08 23:41:00',
    sleepStart: '2022-07-08 23:41:00',
    sleepEnd: '2022-07-09 10:35:02',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '10:54:02',
    notesSleep: 'sit amet diam in magna bibendum',
    notesWake: 'quam sapien varius ut blandit non',
  },
  {
    _id: '62a7f19cfc13ae7eb80000bd',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-09 22:42:22',
    sleepStart: '2022-07-09 22:42:22',
    sleepEnd: '2022-07-10 07:11:26',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '08:29:04',
    notesSleep: 'duis ac nibh fusce lacus purus aliquet at',
    notesWake: 'leo rhoncus sed vestibulum sit amet cursus id',
  },
  {
    _id: '62a7f19cfc13ae7eb80000be',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-10 21:15:35',
    sleepStart: '2022-07-10 21:15:35',
    sleepEnd: '2022-07-11 08:16:52',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '11:01:17',
    notesSleep: 'curae nulla dapibus dolor vel est donec odio',
    notesWake: 'nonummy maecenas tincidunt lacus at',
  },
  {
    _id: '62a7f19cfc13ae7eb80000bf',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-11 21:15:26',
    sleepStart: '2022-07-11 21:15:26',
    sleepEnd: '2022-07-12 07:07:52',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '09:52:26',
    notesSleep: 'consectetuer adipiscing elit proin risus praesent lectus',
    notesWake: 'integer aliquet massa id lobortis convallis',
  },
  {
    _id: '62a7f19cfc13ae7eb80000c0',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-12 23:29:06',
    sleepStart: '2022-07-12 23:29:06',
    sleepEnd: '2022-07-13 08:54:49',
    moodStart: 0,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '09:25:43',
    notesSleep: 'sit amet consectetuer adipiscing elit proin interdum mauris',
    notesWake: 'gravida sem praesent id massa id',
  },
  {
    _id: '62a7f19cfc13ae7eb80000c1',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-13 21:26:30',
    sleepStart: '2022-07-13 21:26:30',
    sleepEnd: '2022-07-14 09:45:56',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '12:19:26',
    notesSleep: 'faucibus cursus urna ut tellus nulla',
    notesWake: 'convallis tortor risus dapibus augue vel',
  },
  {
    _id: '62a7f19cfc13ae7eb80000c2',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-14 21:54:12',
    sleepStart: '2022-07-14 21:54:12',
    sleepEnd: '2022-07-15 07:07:00',
    moodStart: 0,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '09:12:48',
    notesSleep: 'pretium iaculis justo in hac',
    notesWake: 'lorem ipsum dolor sit amet consectetuer adipiscing elit',
  },
  {
    _id: '62a7f19cfc13ae7eb80000c3',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-15 21:28:33',
    sleepStart: '2022-07-15 21:28:33',
    sleepEnd: '2022-07-16 10:11:26',
    moodStart: 0,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '12:42:53',
    notesSleep: 'eros suspendisse accumsan tortor quis turpis sed ante',
    notesWake: 'nec dui luctus rutrum nulla',
  },
  {
    _id: '62a7f19cfc13ae7eb80000c4',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-16 22:40:01',
    sleepStart: '2022-07-16 22:40:01',
    sleepEnd: '2022-07-17 08:33:13',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '09:53:12',
    notesSleep: 'mi sit amet lobortis sapien sapien',
    notesWake: 'mauris lacinia sapien quis libero',
  },
  {
    _id: '62a7f19cfc13ae7eb80000c5',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-17 20:18:44',
    sleepStart: '2022-07-17 20:18:44',
    sleepEnd: '2022-07-18 10:11:29',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '13:52:45',
    notesSleep: 'massa volutpat convallis morbi odio odio elementum eu',
    notesWake: 'nibh ligula nec sem duis',
  },
  {
    _id: '62a7f19cfc13ae7eb80000c6',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-18 22:09:50',
    sleepStart: '2022-07-18 22:09:50',
    sleepEnd: '2022-07-19 06:42:37',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '08:32:47',
    notesSleep: 'platea dictumst aliquam augue quam sollicitudin',
    notesWake: 'suspendisse potenti cras in purus',
  },
  {
    _id: '62a7f19cfc13ae7eb80000c7',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-19 22:16:06',
    sleepStart: '2022-07-19 22:16:06',
    sleepEnd: '2022-07-20 09:25:10',
    moodStart: 3,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '11:09:04',
    notesSleep: 'in lacus curabitur at ipsum',
    notesWake: 'ut dolor morbi vel lectus in',
  },
  {
    _id: '62a7f19dfc13ae7eb80000c8',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-20 21:57:39',
    sleepStart: '2022-07-20 21:57:39',
    sleepEnd: '2022-07-21 08:50:27',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '10:52:48',
    notesSleep: 'hendrerit at vulputate vitae nisl',
    notesWake: 'rutrum neque aenean auctor gravida',
  },
  {
    _id: '62a7f19dfc13ae7eb80000c9',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-21 22:44:20',
    sleepStart: '2022-07-21 22:44:20',
    sleepEnd: '2022-07-22 09:50:58',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '11:06:38',
    notesSleep: 'magnis dis parturient montes nascetur ridiculus mus',
    notesWake: 'orci luctus et ultrices posuere',
  },
  {
    _id: '62a7f19dfc13ae7eb80000ca',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-22 21:45:16',
    sleepStart: '2022-07-22 21:45:16',
    sleepEnd: '2022-07-23 10:39:37',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '12:54:21',
    notesSleep: 'nunc donec quis orci eget orci',
    notesWake: 'erat tortor sollicitudin mi sit amet lobortis',
  },
  {
    _id: '62a7f19dfc13ae7eb80000cb',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-23 20:34:47',
    sleepStart: '2022-07-23 20:34:47',
    sleepEnd: '2022-07-24 06:01:55',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '09:27:08',
    notesSleep: 'justo nec condimentum neque sapien placerat ante nulla',
    notesWake: 'turpis eget elit sodales scelerisque mauris sit',
  },
  {
    _id: '62a7f19dfc13ae7eb80000cc',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-24 21:36:34',
    sleepStart: '2022-07-24 21:36:34',
    sleepEnd: '2022-07-25 07:33:16',
    moodStart: 1,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '09:56:42',
    notesSleep: 'dapibus augue vel accumsan tellus nisi',
    notesWake: 'nisl ut volutpat sapien arcu sed augue aliquam',
  },
  {
    _id: '62a7f19dfc13ae7eb80000cd',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-25 21:57:02',
    sleepStart: '2022-07-25 21:57:02',
    sleepEnd: '2022-07-26 07:12:49',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '09:15:47',
    notesSleep: 'libero nullam sit amet turpis elementum ligula',
    notesWake: 'gravida sem praesent id massa id',
  },
  {
    _id: '62a7f19dfc13ae7eb80000ce',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-26 20:17:41',
    sleepStart: '2022-07-26 20:17:41',
    sleepEnd: '2022-07-27 09:31:20',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '13:13:39',
    notesSleep: 'non interdum in ante vestibulum ante ipsum primis',
    notesWake: 'sapien varius ut blandit non interdum in ante',
  },
  {
    _id: '62a7f19dfc13ae7eb80000cf',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-27 22:50:08',
    sleepStart: '2022-07-27 22:50:08',
    sleepEnd: '2022-07-28 06:25:28',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '07:35:20',
    notesSleep: 'lacinia sapien quis libero nullam sit',
    notesWake: 'mauris vulputate elementum nullam varius',
  },
  {
    _id: '62a7f19dfc13ae7eb80000d0',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-28 20:23:51',
    sleepStart: '2022-07-28 20:23:51',
    sleepEnd: '2022-07-29 07:40:35',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '11:16:44',
    notesSleep: 'amet sapien dignissim vestibulum vestibulum',
    notesWake: 'morbi a ipsum integer a',
  },
  {
    _id: '62a7f19dfc13ae7eb80000d1',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-29 22:07:14',
    sleepStart: '2022-07-29 22:07:14',
    sleepEnd: '2022-07-30 07:21:22',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '09:14:08',
    notesSleep: 'velit nec nisi vulputate nonummy maecenas tincidunt lacus',
    notesWake: 'nibh fusce lacus purus aliquet at feugiat',
  },
  {
    _id: '62a7f19dfc13ae7eb80000d2',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-30 22:54:26',
    sleepStart: '2022-07-30 22:54:26',
    sleepEnd: '2022-07-31 08:05:49',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '09:11:23',
    notesSleep: 'sapien cum sociis natoque penatibus',
    notesWake: 'aliquam sit amet diam in',
  },
  {
    _id: '62a7f19dfc13ae7eb80000d3',
    creator: '623300e3f0323969f1010b28',
    date: '2022-07-31 22:36:24',
    sleepStart: '2022-07-31 22:36:24',
    sleepEnd: '2022-08-01 09:51:23',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '11:14:59',
    notesSleep: 'pede ac diam cras pellentesque volutpat dui',
    notesWake: 'sit amet sapien dignissim vestibulum vestibulum ante',
  },
  {
    _id: '62a7f19dfc13ae7eb80000d4',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-01 22:59:33',
    sleepStart: '2022-08-01 22:59:33',
    sleepEnd: '2022-08-02 09:56:45',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '10:57:12',
    notesSleep: 'convallis duis consequat dui nec',
    notesWake: 'nulla sed vel enim sit amet nunc',
  },
  {
    _id: '62a7f19dfc13ae7eb80000d5',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-02 20:26:49',
    sleepStart: '2022-08-02 20:26:49',
    sleepEnd: '2022-08-03 09:30:03',
    moodStart: 1,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '13:03:14',
    notesSleep: 'dignissim vestibulum vestibulum ante ipsum primis in',
    notesWake: 'pretium iaculis justo in hac',
  },
  {
    _id: '62a7f19dfc13ae7eb80000d6',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-03 22:39:08',
    sleepStart: '2022-08-03 22:39:08',
    sleepEnd: '2022-08-04 06:24:23',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '07:45:15',
    notesSleep: 'risus praesent lectus vestibulum quam sapien varius ut',
    notesWake: 'dolor morbi vel lectus in quam fringilla rhoncus',
  },
  {
    _id: '62a7f19dfc13ae7eb80000d7',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-04 21:34:00',
    sleepStart: '2022-08-04 21:34:00',
    sleepEnd: '2022-08-05 06:02:24',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '08:28:24',
    notesSleep: 'augue a suscipit nulla elit',
    notesWake: 'tempus sit amet sem fusce consequat',
  },
  {
    _id: '62a7f19dfc13ae7eb80000d8',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-05 21:25:48',
    sleepStart: '2022-08-05 21:25:48',
    sleepEnd: '2022-08-06 08:05:36',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '10:39:48',
    notesSleep: 'vel nisl duis ac nibh fusce lacus purus',
    notesWake: 'interdum in ante vestibulum ante ipsum',
  },
  {
    _id: '62a7f19dfc13ae7eb80000d9',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-06 21:53:37',
    sleepStart: '2022-08-06 21:53:37',
    sleepEnd: '2022-08-07 07:45:08',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '09:51:31',
    notesSleep: 'pede ullamcorper augue a suscipit nulla',
    notesWake: 'orci nullam molestie nibh in lectus',
  },
  {
    _id: '62a7f19dfc13ae7eb80000da',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-07 23:05:51',
    sleepStart: '2022-08-07 23:05:51',
    sleepEnd: '2022-08-08 09:39:50',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '10:33:59',
    notesSleep: 'blandit non interdum in ante vestibulum ante',
    notesWake: 'elit proin interdum mauris non ligula pellentesque',
  },
  {
    _id: '62a7f19dfc13ae7eb80000db',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-08 23:39:45',
    sleepStart: '2022-08-08 23:39:45',
    sleepEnd: '2022-08-09 09:44:29',
    moodStart: 0,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '10:04:44',
    notesSleep: 'turpis donec posuere metus vitae ipsum aliquam non',
    notesWake: 'turpis nec euismod scelerisque quam turpis adipiscing lorem',
  },
  {
    _id: '62a7f19dfc13ae7eb80000dc',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-09 23:45:28',
    sleepStart: '2022-08-09 23:45:28',
    sleepEnd: '2022-08-10 09:19:15',
    moodStart: 1,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '09:33:47',
    notesSleep: 'eleifend quam a odio in hac habitasse',
    notesWake: 'commodo vulputate justo in blandit',
  },
  {
    _id: '62a7f19dfc13ae7eb80000dd',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-10 20:38:01',
    sleepStart: '2022-08-10 20:38:01',
    sleepEnd: '2022-08-11 10:42:13',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '14:04:12',
    notesSleep: 'turpis a pede posuere nonummy integer non',
    notesWake: 'hendrerit at vulputate vitae nisl aenean',
  },
  {
    _id: '62a7f19dfc13ae7eb80000de',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-11 21:46:03',
    sleepStart: '2022-08-11 21:46:03',
    sleepEnd: '2022-08-12 06:35:39',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '08:49:36',
    notesSleep: 'etiam faucibus cursus urna ut tellus nulla ut',
    notesWake: 'in faucibus orci luctus et',
  },
  {
    _id: '62a7f19dfc13ae7eb80000df',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-12 21:27:45',
    sleepStart: '2022-08-12 21:27:45',
    sleepEnd: '2022-08-13 10:56:33',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '13:28:48',
    notesSleep: 'in magna bibendum imperdiet nullam orci pede',
    notesWake: 'cubilia curae nulla dapibus dolor vel',
  },
  {
    _id: '62a7f19dfc13ae7eb80000e0',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-13 20:32:11',
    sleepStart: '2022-08-13 20:32:11',
    sleepEnd: '2022-08-14 10:39:42',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '14:07:31',
    notesSleep: 'in blandit ultrices enim lorem ipsum dolor',
    notesWake: 'ut at dolor quis odio',
  },
  {
    _id: '62a7f19dfc13ae7eb80000e1',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-14 22:30:14',
    sleepStart: '2022-08-14 22:30:14',
    sleepEnd: '2022-08-15 06:32:04',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '08:01:50',
    notesSleep: 'ultrices posuere cubilia curae donec pharetra',
    notesWake: 'eros suspendisse accumsan tortor quis',
  },
  {
    _id: '62a7f19dfc13ae7eb80000e2',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-15 20:47:19',
    sleepStart: '2022-08-15 20:47:19',
    sleepEnd: '2022-08-16 08:09:32',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '11:22:13',
    notesSleep: 'lobortis est phasellus sit amet erat',
    notesWake: 'sollicitudin ut suscipit a feugiat et eros vestibulum',
  },
  {
    _id: '62a7f19dfc13ae7eb80000e3',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-16 21:17:14',
    sleepStart: '2022-08-16 21:17:14',
    sleepEnd: '2022-08-17 07:22:51',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '10:05:37',
    notesSleep: 'pede lobortis ligula sit amet eleifend',
    notesWake: 'dapibus nulla suscipit ligula in',
  },
  {
    _id: '62a7f19dfc13ae7eb80000e4',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-17 20:50:23',
    sleepStart: '2022-08-17 20:50:23',
    sleepEnd: '2022-08-18 07:06:36',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '10:16:13',
    notesSleep: 'ipsum aliquam non mauris morbi non',
    notesWake: 'amet diam in magna bibendum',
  },
  {
    _id: '62a7f19dfc13ae7eb80000e5',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-18 20:03:10',
    sleepStart: '2022-08-18 20:03:10',
    sleepEnd: '2022-08-19 10:36:30',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '14:33:20',
    notesSleep: 'leo odio porttitor id consequat in consequat',
    notesWake: 'luctus ultricies eu nibh quisque id justo sit',
  },
  {
    _id: '62a7f19dfc13ae7eb80000e6',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-19 23:40:44',
    sleepStart: '2022-08-19 23:40:44',
    sleepEnd: '2022-08-20 09:33:21',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '09:52:37',
    notesSleep: 'odio porttitor id consequat in',
    notesWake: 'non mattis pulvinar nulla pede ullamcorper augue a',
  },
  {
    _id: '62a7f19dfc13ae7eb80000e7',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-20 23:43:25',
    sleepStart: '2022-08-20 23:43:25',
    sleepEnd: '2022-08-21 07:31:37',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '07:48:12',
    notesSleep: 'ut dolor morbi vel lectus in quam fringilla',
    notesWake: 'arcu sed augue aliquam erat volutpat in congue',
  },
  {
    _id: '62a7f19dfc13ae7eb80000e8',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-21 20:33:48',
    sleepStart: '2022-08-21 20:33:48',
    sleepEnd: '2022-08-22 06:36:53',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '10:03:05',
    notesSleep: 'et commodo vulputate justo in blandit ultrices',
    notesWake: 'nisl nunc nisl duis bibendum felis sed interdum',
  },
  {
    _id: '62a7f19dfc13ae7eb80000e9',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-22 22:42:06',
    sleepStart: '2022-08-22 22:42:06',
    sleepEnd: '2022-08-23 08:34:54',
    moodStart: 1,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '09:52:48',
    notesSleep: 'justo in blandit ultrices enim lorem ipsum',
    notesWake: 'ante ipsum primis in faucibus orci luctus et',
  },
  {
    _id: '62a7f19dfc13ae7eb80000ea',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-23 20:18:34',
    sleepStart: '2022-08-23 20:18:34',
    sleepEnd: '2022-08-24 06:49:23',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '10:30:49',
    notesSleep: 'eleifend donec ut dolor morbi vel lectus',
    notesWake: 'integer pede justo lacinia eget tincidunt eget tempus',
  },
  {
    _id: '62a7f19dfc13ae7eb80000eb',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-24 20:50:15',
    sleepStart: '2022-08-24 20:50:15',
    sleepEnd: '2022-08-25 06:25:17',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '09:35:02',
    notesSleep: 'a pede posuere nonummy integer non velit donec',
    notesWake: 'posuere cubilia curae duis faucibus accumsan odio curabitur',
  },
  {
    _id: '62a7f19dfc13ae7eb80000ec',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-25 22:51:55',
    sleepStart: '2022-08-25 22:51:55',
    sleepEnd: '2022-08-26 10:06:58',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '11:15:03',
    notesSleep: 'eu tincidunt in leo maecenas',
    notesWake: 'tempus sit amet sem fusce consequat nulla',
  },
  {
    _id: '62a7f19dfc13ae7eb80000ed',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-26 21:32:23',
    sleepStart: '2022-08-26 21:32:23',
    sleepEnd: '2022-08-27 08:44:59',
    moodStart: 0,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '11:12:36',
    notesSleep: 'in tempus sit amet sem',
    notesWake: 'sapien quis libero nullam sit amet',
  },
  {
    _id: '62a7f19dfc13ae7eb80000ee',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-27 22:51:11',
    sleepStart: '2022-08-27 22:51:11',
    sleepEnd: '2022-08-28 10:39:42',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '11:48:31',
    notesSleep: 'morbi non quam nec dui luctus rutrum',
    notesWake: 'vel pede morbi porttitor lorem id',
  },
  {
    _id: '62a7f19dfc13ae7eb80000ef',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-28 21:44:23',
    sleepStart: '2022-08-28 21:44:23',
    sleepEnd: '2022-08-29 08:21:25',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '10:37:02',
    notesSleep: 'eget rutrum at lorem integer tincidunt ante',
    notesWake: 'ipsum primis in faucibus orci luctus et',
  },
  {
    _id: '62a7f19dfc13ae7eb80000f0',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-29 20:46:08',
    sleepStart: '2022-08-29 20:46:08',
    sleepEnd: '2022-08-30 06:25:23',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '09:39:15',
    notesSleep: 'iaculis justo in hac habitasse',
    notesWake: 'donec vitae nisi nam ultrices libero non mattis',
  },
  {
    _id: '62a7f19dfc13ae7eb80000f1',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-30 21:14:41',
    sleepStart: '2022-08-30 21:14:41',
    sleepEnd: '2022-08-31 09:48:57',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '12:34:16',
    notesSleep: 'mauris non ligula pellentesque ultrices phasellus id sapien',
    notesWake: 'maecenas tincidunt lacus at velit',
  },
  {
    _id: '62a7f19dfc13ae7eb80000f2',
    creator: '623300e3f0323969f1010b28',
    date: '2022-08-31 21:27:44',
    sleepStart: '2022-08-31 21:27:44',
    sleepEnd: '2022-09-01 07:54:34',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '10:26:50',
    notesSleep: 'duis bibendum felis sed interdum',
    notesWake: 'libero nam dui proin leo odio porttitor id',
  },
  {
    _id: '62a7f19dfc13ae7eb80000f3',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-01 22:22:53',
    sleepStart: '2022-09-01 22:22:53',
    sleepEnd: '2022-09-02 06:32:17',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '08:09:24',
    notesSleep: 'tortor quis turpis sed ante vivamus tortor duis',
    notesWake: 'tempor turpis nec euismod scelerisque',
  },
  {
    _id: '62a7f19dfc13ae7eb80000f4',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-02 21:08:14',
    sleepStart: '2022-09-02 21:08:14',
    sleepEnd: '2022-09-03 07:55:56',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '10:47:42',
    notesSleep: 'eu sapien cursus vestibulum proin eu mi',
    notesWake: 'lectus vestibulum quam sapien varius ut blandit',
  },
  {
    _id: '62a7f19dfc13ae7eb80000f5',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-03 21:25:09',
    sleepStart: '2022-09-03 21:25:09',
    sleepEnd: '2022-09-04 06:45:11',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '09:20:02',
    notesSleep: 'primis in faucibus orci luctus',
    notesWake: 'sapien varius ut blandit non interdum',
  },
  {
    _id: '62a7f19dfc13ae7eb80000f6',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-04 21:25:55',
    sleepStart: '2022-09-04 21:25:55',
    sleepEnd: '2022-09-05 09:57:56',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '12:32:01',
    notesSleep: 'ut suscipit a feugiat et eros vestibulum ac',
    notesWake: 'molestie lorem quisque ut erat',
  },
  {
    _id: '62a7f19dfc13ae7eb80000f7',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-05 23:53:30',
    sleepStart: '2022-09-05 23:53:30',
    sleepEnd: '2022-09-06 06:11:16',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '06:17:46',
    notesSleep: 'in quam fringilla rhoncus mauris enim',
    notesWake: 'sem fusce consequat nulla nisl nunc nisl',
  },
  {
    _id: '62a7f19dfc13ae7eb80000f8',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-06 23:34:42',
    sleepStart: '2022-09-06 23:34:42',
    sleepEnd: '2022-09-07 06:20:14',
    moodStart: 0,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '06:45:32',
    notesSleep: 'morbi vestibulum velit id pretium iaculis diam',
    notesWake: 'ut massa volutpat convallis morbi odio odio',
  },
  {
    _id: '62a7f19dfc13ae7eb80000f9',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-07 20:40:20',
    sleepStart: '2022-09-07 20:40:20',
    sleepEnd: '2022-09-08 10:40:43',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '14:00:23',
    notesSleep: 'ornare consequat lectus in est risus',
    notesWake: 'dapibus nulla suscipit ligula in lacus',
  },
  {
    _id: '62a7f19dfc13ae7eb80000fa',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-08 21:45:16',
    sleepStart: '2022-09-08 21:45:16',
    sleepEnd: '2022-09-09 08:38:31',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '10:53:15',
    notesSleep: 'condimentum curabitur in libero ut massa volutpat',
    notesWake: 'velit nec nisi vulputate nonummy maecenas tincidunt lacus',
  },
  {
    _id: '62a7f19dfc13ae7eb80000fb',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-09 22:23:45',
    sleepStart: '2022-09-09 22:23:45',
    sleepEnd: '2022-09-10 07:09:31',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '08:45:46',
    notesSleep: 'tortor duis mattis egestas metus aenean',
    notesWake: 'natoque penatibus et magnis dis parturient montes nascetur',
  },
  {
    _id: '62a7f19dfc13ae7eb80000fc',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-10 22:33:37',
    sleepStart: '2022-09-10 22:33:37',
    sleepEnd: '2022-09-11 10:39:36',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '12:05:59',
    notesSleep: 'non ligula pellentesque ultrices phasellus',
    notesWake: 'fusce congue diam id ornare imperdiet sapien',
  },
  {
    _id: '62a7f19dfc13ae7eb80000fd',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-11 23:30:15',
    sleepStart: '2022-09-11 23:30:15',
    sleepEnd: '2022-09-12 08:38:31',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '09:08:16',
    notesSleep: 'augue luctus tincidunt nulla mollis molestie lorem quisque',
    notesWake: 'amet cursus id turpis integer aliquet massa',
  },
  {
    _id: '62a7f19dfc13ae7eb80000fe',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-12 21:17:38',
    sleepStart: '2022-09-12 21:17:38',
    sleepEnd: '2022-09-13 08:48:54',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '11:31:16',
    notesSleep: 'volutpat in congue etiam justo',
    notesWake: 'primis in faucibus orci luctus et ultrices',
  },
  {
    _id: '62a7f19dfc13ae7eb80000ff',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-13 23:57:08',
    sleepStart: '2022-09-13 23:57:08',
    sleepEnd: '2022-09-14 10:36:08',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '10:39:00',
    notesSleep: 'lectus vestibulum quam sapien varius ut blandit non',
    notesWake: 'quis augue luctus tincidunt nulla mollis molestie',
  },
  {
    _id: '62a7f19dfc13ae7eb8000100',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-14 20:58:03',
    sleepStart: '2022-09-14 20:58:03',
    sleepEnd: '2022-09-15 06:10:54',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '09:12:51',
    notesSleep: 'venenatis turpis enim blandit mi in porttitor pede',
    notesWake: 'elit proin risus praesent lectus vestibulum quam',
  },
  {
    _id: '62a7f19dfc13ae7eb8000101',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-15 23:01:55',
    sleepStart: '2022-09-15 23:01:55',
    sleepEnd: '2022-09-16 06:00:20',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '06:58:25',
    notesSleep: 'eget vulputate ut ultrices vel augue',
    notesWake: 'sed ante vivamus tortor duis',
  },
  {
    _id: '62a7f19dfc13ae7eb8000102',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-16 20:43:13',
    sleepStart: '2022-09-16 20:43:13',
    sleepEnd: '2022-09-17 07:25:51',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '10:42:38',
    notesSleep: 'integer non velit donec diam neque vestibulum',
    notesWake: 'placerat ante nulla justo aliquam quis',
  },
  {
    _id: '62a7f19dfc13ae7eb8000103',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-17 23:34:16',
    sleepStart: '2022-09-17 23:34:16',
    sleepEnd: '2022-09-18 09:04:48',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '09:30:32',
    notesSleep: 'pede lobortis ligula sit amet eleifend',
    notesWake: 'platea dictumst morbi vestibulum velit id pretium iaculis',
  },
  {
    _id: '62a7f19dfc13ae7eb8000104',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-18 21:21:04',
    sleepStart: '2022-09-18 21:21:04',
    sleepEnd: '2022-09-19 10:12:34',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '12:51:30',
    notesSleep: 'vitae mattis nibh ligula nec sem',
    notesWake: 'pede justo lacinia eget tincidunt eget tempus',
  },
  {
    _id: '62a7f19dfc13ae7eb8000105',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-19 21:29:40',
    sleepStart: '2022-09-19 21:29:40',
    sleepEnd: '2022-09-20 07:48:44',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '10:19:04',
    notesSleep: 'justo nec condimentum neque sapien placerat ante',
    notesWake: 'feugiat non pretium quis lectus',
  },
  {
    _id: '62a7f19dfc13ae7eb8000106',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-20 21:56:31',
    sleepStart: '2022-09-20 21:56:31',
    sleepEnd: '2022-09-21 10:40:05',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '12:43:34',
    notesSleep: 'nec nisi vulputate nonummy maecenas tincidunt lacus',
    notesWake: 'ultrices libero non mattis pulvinar nulla',
  },
  {
    _id: '62a7f19efc13ae7eb8000107',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-21 22:46:38',
    sleepStart: '2022-09-21 22:46:38',
    sleepEnd: '2022-09-22 10:03:46',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '11:17:08',
    notesSleep: 'praesent blandit nam nulla integer pede justo',
    notesWake: 'enim leo rhoncus sed vestibulum',
  },
  {
    _id: '62a7f19efc13ae7eb8000108',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-22 23:45:50',
    sleepStart: '2022-09-22 23:45:50',
    sleepEnd: '2022-09-23 08:01:02',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '08:15:12',
    notesSleep: 'pellentesque quisque porta volutpat erat',
    notesWake: 'augue vestibulum ante ipsum primis',
  },
  {
    _id: '62a7f19efc13ae7eb8000109',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-23 23:09:39',
    sleepStart: '2022-09-23 23:09:39',
    sleepEnd: '2022-09-24 06:28:55',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '07:19:16',
    notesSleep: 'magna ac consequat metus sapien ut',
    notesWake: 'gravida nisi at nibh in hac habitasse platea',
  },
  {
    _id: '62a7f19efc13ae7eb800010a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-24 21:35:53',
    sleepStart: '2022-09-24 21:35:53',
    sleepEnd: '2022-09-25 10:55:20',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '13:19:27',
    notesSleep: 'justo sollicitudin ut suscipit a feugiat et',
    notesWake: 'elementum eu interdum eu tincidunt',
  },
  {
    _id: '62a7f19efc13ae7eb800010b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-25 23:55:45',
    sleepStart: '2022-09-25 23:55:45',
    sleepEnd: '2022-09-26 06:43:08',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '06:47:23',
    notesSleep: 'integer a nibh in quis justo',
    notesWake: 'blandit lacinia erat vestibulum sed magna at nunc',
  },
  {
    _id: '62a7f19efc13ae7eb800010c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-26 21:40:52',
    sleepStart: '2022-09-26 21:40:52',
    sleepEnd: '2022-09-27 08:00:30',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '10:19:38',
    notesSleep: 'diam vitae quam suspendisse potenti nullam porttitor',
    notesWake: 'ante ipsum primis in faucibus orci luctus et',
  },
  {
    _id: '62a7f19efc13ae7eb800010d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-27 23:06:15',
    sleepStart: '2022-09-27 23:06:15',
    sleepEnd: '2022-09-28 06:46:46',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '07:40:31',
    notesSleep: 'dolor quis odio consequat varius',
    notesWake: 'aliquet maecenas leo odio condimentum id',
  },
  {
    _id: '62a7f19efc13ae7eb800010e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-28 20:26:01',
    sleepStart: '2022-09-28 20:26:01',
    sleepEnd: '2022-09-29 09:44:00',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '13:17:59',
    notesSleep: 'purus sit amet nulla quisque arcu libero',
    notesWake: 'odio condimentum id luctus nec molestie',
  },
  {
    _id: '62a7f19efc13ae7eb800010f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-29 20:00:39',
    sleepStart: '2022-09-29 20:00:39',
    sleepEnd: '2022-09-30 06:34:43',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '10:34:04',
    notesSleep: 'morbi a ipsum integer a nibh',
    notesWake:
      'eros elementum pellentesque quisque porta volutpat erat quisque',
  },
  {
    _id: '62a7f19efc13ae7eb8000110',
    creator: '623300e3f0323969f1010b28',
    date: '2022-09-30 21:14:59',
    sleepStart: '2022-09-30 21:14:59',
    sleepEnd: '2022-10-01 09:10:49',
    moodStart: 0,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '11:55:50',
    notesSleep: 'cursus id turpis integer aliquet massa id lobortis',
    notesWake: 'viverra diam vitae quam suspendisse',
  },
  {
    _id: '62a7f19efc13ae7eb8000111',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-01 20:24:02',
    sleepStart: '2022-10-01 20:24:02',
    sleepEnd: '2022-10-02 09:41:15',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '13:17:13',
    notesSleep: 'consequat in consequat ut nulla sed accumsan',
    notesWake: 'neque duis bibendum morbi non',
  },
  {
    _id: '62a7f19efc13ae7eb8000112',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-02 21:13:36',
    sleepStart: '2022-10-02 21:13:36',
    sleepEnd: '2022-10-03 08:47:20',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '11:33:44',
    notesSleep: 'sit amet consectetuer adipiscing elit proin',
    notesWake: 'morbi odio odio elementum eu interdum eu tincidunt',
  },
  {
    _id: '62a7f19efc13ae7eb8000113',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-03 23:27:19',
    sleepStart: '2022-10-03 23:27:19',
    sleepEnd: '2022-10-04 10:23:46',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '10:56:27',
    notesSleep: 'semper interdum mauris ullamcorper purus sit amet',
    notesWake: 'sit amet consectetuer adipiscing elit proin risus praesent',
  },
  {
    _id: '62a7f19efc13ae7eb8000114',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-04 23:32:21',
    sleepStart: '2022-10-04 23:32:21',
    sleepEnd: '2022-10-05 10:11:08',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '10:38:47',
    notesSleep: 'consequat morbi a ipsum integer a',
    notesWake: 'consectetuer adipiscing elit proin interdum mauris',
  },
  {
    _id: '62a7f19efc13ae7eb8000115',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-05 21:02:56',
    sleepStart: '2022-10-05 21:02:56',
    sleepEnd: '2022-10-06 08:41:27',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '11:38:31',
    notesSleep: 'sapien a libero nam dui',
    notesWake: 'posuere cubilia curae mauris viverra',
  },
  {
    _id: '62a7f19efc13ae7eb8000116',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-06 23:48:17',
    sleepStart: '2022-10-06 23:48:17',
    sleepEnd: '2022-10-07 07:12:02',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '07:23:45',
    notesSleep: 'quis odio consequat varius integer',
    notesWake: 'condimentum curabitur in libero ut massa',
  },
  {
    _id: '62a7f19efc13ae7eb8000117',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-07 23:29:44',
    sleepStart: '2022-10-07 23:29:44',
    sleepEnd: '2022-10-08 10:19:34',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '10:49:50',
    notesSleep: 'venenatis non sodales sed tincidunt',
    notesWake: 'sed magna at nunc commodo placerat praesent',
  },
  {
    _id: '62a7f19efc13ae7eb8000118',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-08 21:55:26',
    sleepStart: '2022-10-08 21:55:26',
    sleepEnd: '2022-10-09 06:00:09',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '08:04:43',
    notesSleep: 'justo pellentesque viverra pede ac diam cras',
    notesWake: 'euismod scelerisque quam turpis adipiscing',
  },
  {
    _id: '62a7f19efc13ae7eb8000119',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-09 21:02:50',
    sleepStart: '2022-10-09 21:02:50',
    sleepEnd: '2022-10-10 06:09:51',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '09:07:01',
    notesSleep: 'luctus et ultrices posuere cubilia curae',
    notesWake: 'turpis nec euismod scelerisque quam turpis adipiscing lorem',
  },
  {
    _id: '62a7f19efc13ae7eb800011a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-10 21:52:31',
    sleepStart: '2022-10-10 21:52:31',
    sleepEnd: '2022-10-11 08:10:21',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '10:17:50',
    notesSleep: 'fermentum justo nec condimentum neque',
    notesWake: 'dolor vel est donec odio justo sollicitudin ut',
  },
  {
    _id: '62a7f19efc13ae7eb800011b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-11 22:43:31',
    sleepStart: '2022-10-11 22:43:31',
    sleepEnd: '2022-10-12 07:06:13',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '08:22:42',
    notesSleep: 'dapibus nulla suscipit ligula in',
    notesWake: 'venenatis lacinia aenean sit amet justo',
  },
  {
    _id: '62a7f19efc13ae7eb800011c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-12 23:06:00',
    sleepStart: '2022-10-12 23:06:00',
    sleepEnd: '2022-10-13 07:06:52',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '08:00:52',
    notesSleep: 'dui maecenas tristique est et tempus semper est',
    notesWake: 'turpis elementum ligula vehicula consequat morbi a',
  },
  {
    _id: '62a7f19efc13ae7eb800011d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-13 22:22:45',
    sleepStart: '2022-10-13 22:22:45',
    sleepEnd: '2022-10-14 09:37:46',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '11:15:01',
    notesSleep: 'risus praesent lectus vestibulum quam sapien',
    notesWake: 'duis consequat dui nec nisi',
  },
  {
    _id: '62a7f19efc13ae7eb800011e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-14 20:23:34',
    sleepStart: '2022-10-14 20:23:34',
    sleepEnd: '2022-10-15 08:14:38',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '11:51:04',
    notesSleep: 'morbi ut odio cras mi pede malesuada',
    notesWake: 'in ante vestibulum ante ipsum',
  },
  {
    _id: '62a7f19efc13ae7eb800011f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-15 20:31:26',
    sleepStart: '2022-10-15 20:31:26',
    sleepEnd: '2022-10-16 07:14:31',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '10:43:05',
    notesSleep: 'volutpat sapien arcu sed augue aliquam erat',
    notesWake: 'sed lacus morbi sem mauris laoreet ut',
  },
  {
    _id: '62a7f19efc13ae7eb8000120',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-16 20:01:39',
    sleepStart: '2022-10-16 20:01:39',
    sleepEnd: '2022-10-17 10:32:59',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '14:31:20',
    notesSleep: 'ipsum dolor sit amet consectetuer adipiscing elit',
    notesWake: 'ipsum ac tellus semper interdum mauris',
  },
  {
    _id: '62a7f19efc13ae7eb8000121',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-17 21:31:32',
    sleepStart: '2022-10-17 21:31:32',
    sleepEnd: '2022-10-18 09:57:05',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '12:25:33',
    notesSleep: 'luctus et ultrices posuere cubilia curae',
    notesWake: 'aliquam quis turpis eget elit sodales scelerisque',
  },
  {
    _id: '62a7f19efc13ae7eb8000122',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-18 21:11:32',
    sleepStart: '2022-10-18 21:11:32',
    sleepEnd: '2022-10-19 10:07:45',
    moodStart: 3,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '12:56:13',
    notesSleep: 'justo in blandit ultrices enim',
    notesWake: 'cursus urna ut tellus nulla ut erat id',
  },
  {
    _id: '62a7f19efc13ae7eb8000123',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-19 22:28:12',
    sleepStart: '2022-10-19 22:28:12',
    sleepEnd: '2022-10-20 09:37:03',
    moodStart: 0,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '11:08:51',
    notesSleep: 'erat volutpat in congue etiam justo etiam pretium',
    notesWake: 'amet nulla quisque arcu libero rutrum',
  },
  {
    _id: '62a7f19efc13ae7eb8000124',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-20 20:00:48',
    sleepStart: '2022-10-20 20:00:48',
    sleepEnd: '2022-10-21 07:45:09',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '11:44:21',
    notesSleep: 'lacinia nisi venenatis tristique fusce',
    notesWake: 'congue eget semper rutrum nulla nunc purus phasellus',
  },
  {
    _id: '62a7f19efc13ae7eb8000125',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-21 21:09:00',
    sleepStart: '2022-10-21 21:09:00',
    sleepEnd: '2022-10-22 10:24:28',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '13:15:28',
    notesSleep: 'nullam orci pede venenatis non',
    notesWake: 'diam vitae quam suspendisse potenti',
  },
  {
    _id: '62a7f19efc13ae7eb8000126',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-22 20:54:19',
    sleepStart: '2022-10-22 20:54:19',
    sleepEnd: '2022-10-23 09:14:37',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '12:20:18',
    notesSleep: 'mattis egestas metus aenean fermentum donec ut',
    notesWake: 'volutpat dui maecenas tristique est et tempus',
  },
  {
    _id: '62a7f19efc13ae7eb8000127',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-23 21:20:51',
    sleepStart: '2022-10-23 21:20:51',
    sleepEnd: '2022-10-24 09:10:32',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '11:49:41',
    notesSleep: 'lacinia sapien quis libero nullam sit',
    notesWake: 'id mauris vulputate elementum nullam varius nulla facilisi',
  },
  {
    _id: '62a7f19efc13ae7eb8000128',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-24 23:51:22',
    sleepStart: '2022-10-24 23:51:22',
    sleepEnd: '2022-10-25 10:04:28',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '10:13:06',
    notesSleep: 'proin leo odio porttitor id',
    notesWake: 'etiam vel augue vestibulum rutrum rutrum neque aenean',
  },
  {
    _id: '62a7f19efc13ae7eb8000129',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-25 22:53:01',
    sleepStart: '2022-10-25 22:53:01',
    sleepEnd: '2022-10-26 10:09:02',
    moodStart: 3,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '11:16:01',
    notesSleep: 'diam erat fermentum justo nec condimentum',
    notesWake: 'sed vestibulum sit amet cursus',
  },
  {
    _id: '62a7f19efc13ae7eb800012a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-26 22:09:09',
    sleepStart: '2022-10-26 22:09:09',
    sleepEnd: '2022-10-27 09:07:05',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '10:57:56',
    notesSleep: 'volutpat sapien arcu sed augue',
    notesWake: 'tristique in tempus sit amet sem',
  },
  {
    _id: '62a7f19efc13ae7eb800012b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-27 20:08:48',
    sleepStart: '2022-10-27 20:08:48',
    sleepEnd: '2022-10-28 08:29:29',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '12:20:41',
    notesSleep: 'elementum eu interdum eu tincidunt in',
    notesWake: 'purus sit amet nulla quisque arcu libero rutrum',
  },
  {
    _id: '62a7f19efc13ae7eb800012c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-28 20:29:54',
    sleepStart: '2022-10-28 20:29:54',
    sleepEnd: '2022-10-29 06:09:19',
    moodStart: 3,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '09:39:25',
    notesSleep: 'quam suspendisse potenti nullam porttitor lacus',
    notesWake: 'ut tellus nulla ut erat',
  },
  {
    _id: '62a7f19efc13ae7eb800012d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-29 20:44:19',
    sleepStart: '2022-10-29 20:44:19',
    sleepEnd: '2022-10-30 09:05:13',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '12:20:54',
    notesSleep: 'lectus in quam fringilla rhoncus mauris enim leo',
    notesWake: 'et ultrices posuere cubilia curae duis faucibus accumsan',
  },
  {
    _id: '62a7f19efc13ae7eb800012e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-30 22:17:57',
    sleepStart: '2022-10-30 22:17:57',
    sleepEnd: '2022-10-31 09:32:04',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '11:14:07',
    notesSleep: 'egestas metus aenean fermentum donec ut mauris',
    notesWake: 'nunc proin at turpis a pede posuere',
  },
  {
    _id: '62a7f19efc13ae7eb800012f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-10-31 20:13:06',
    sleepStart: '2022-10-31 20:13:06',
    sleepEnd: '2022-11-01 07:11:28',
    moodStart: 0,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '10:58:22',
    notesSleep: 'morbi odio odio elementum eu interdum',
    notesWake: 'odio odio elementum eu interdum',
  },
  {
    _id: '62a7f19efc13ae7eb8000130',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-01 23:37:52',
    sleepStart: '2022-11-01 23:37:52',
    sleepEnd: '2022-11-02 10:36:39',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '10:58:47',
    notesSleep: 'non pretium quis lectus suspendisse potenti',
    notesWake: 'in sagittis dui vel nisl',
  },
  {
    _id: '62a7f19efc13ae7eb8000131',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-02 22:02:47',
    sleepStart: '2022-11-02 22:02:47',
    sleepEnd: '2022-11-03 06:56:59',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '08:54:12',
    notesSleep: 'erat id mauris vulputate elementum nullam varius',
    notesWake: 'non mi integer ac neque duis bibendum morbi',
  },
  {
    _id: '62a7f19efc13ae7eb8000132',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-03 20:03:01',
    sleepStart: '2022-11-03 20:03:01',
    sleepEnd: '2022-11-04 06:04:19',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '10:01:18',
    notesSleep: 'dui proin leo odio porttitor id consequat',
    notesWake: 'curae nulla dapibus dolor vel est donec odio',
  },
  {
    _id: '62a7f19efc13ae7eb8000133',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-04 23:14:39',
    sleepStart: '2022-11-04 23:14:39',
    sleepEnd: '2022-11-05 07:32:56',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '08:18:17',
    notesSleep: 'rutrum neque aenean auctor gravida sem praesent id',
    notesWake: 'morbi sem mauris laoreet ut',
  },
  {
    _id: '62a7f19efc13ae7eb8000134',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-05 21:15:55',
    sleepStart: '2022-11-05 21:15:55',
    sleepEnd: '2022-11-06 08:20:29',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '12:04:34',
    notesSleep: 'sit amet nulla quisque arcu libero',
    notesWake: 'integer ac leo pellentesque ultrices mattis odio donec',
  },
  {
    _id: '62a7f19efc13ae7eb8000135',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-06 23:02:18',
    sleepStart: '2022-11-06 23:02:18',
    sleepEnd: '2022-11-07 08:43:20',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '09:41:02',
    notesSleep: 'sit amet nulla quisque arcu',
    notesWake: 'pede posuere nonummy integer non',
  },
  {
    _id: '62a7f19efc13ae7eb8000136',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-07 20:44:47',
    sleepStart: '2022-11-07 20:44:47',
    sleepEnd: '2022-11-08 10:12:05',
    moodStart: 1,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '13:27:18',
    notesSleep: 'sed tincidunt eu felis fusce posuere felis',
    notesWake: 'porttitor pede justo eu massa donec dapibus',
  },
  {
    _id: '62a7f19efc13ae7eb8000137',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-08 23:11:58',
    sleepStart: '2022-11-08 23:11:58',
    sleepEnd: '2022-11-09 08:40:40',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '09:28:42',
    notesSleep: 'magnis dis parturient montes nascetur ridiculus mus etiam',
    notesWake: 'nibh in lectus pellentesque at nulla suspendisse potenti',
  },
  {
    _id: '62a7f19efc13ae7eb8000138',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-09 21:46:30',
    sleepStart: '2022-11-09 21:46:30',
    sleepEnd: '2022-11-10 09:17:52',
    moodStart: 1,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '11:31:22',
    notesSleep: 'felis sed lacus morbi sem mauris',
    notesWake: 'diam neque vestibulum eget vulputate ut',
  },
  {
    _id: '62a7f19efc13ae7eb8000139',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-10 20:51:47',
    sleepStart: '2022-11-10 20:51:47',
    sleepEnd: '2022-11-11 06:33:32',
    moodStart: 0,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '09:41:45',
    notesSleep: 'justo etiam pretium iaculis justo in hac',
    notesWake: 'dui luctus rutrum nulla tellus',
  },
  {
    _id: '62a7f19efc13ae7eb800013a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-11 23:20:52',
    sleepStart: '2022-11-11 23:20:52',
    sleepEnd: '2022-11-12 06:04:57',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '06:44:05',
    notesSleep: 'nibh ligula nec sem duis aliquam convallis nunc',
    notesWake: 'ultrices enim lorem ipsum dolor',
  },
  {
    _id: '62a7f19efc13ae7eb800013b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-12 22:33:07',
    sleepStart: '2022-11-12 22:33:07',
    sleepEnd: '2022-11-13 09:09:16',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '10:36:09',
    notesSleep: 'dui proin leo odio porttitor id consequat',
    notesWake: 'lobortis convallis tortor risus dapibus augue',
  },
  {
    _id: '62a7f19efc13ae7eb800013c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-13 20:30:04',
    sleepStart: '2022-11-13 20:30:04',
    sleepEnd: '2022-11-14 06:54:49',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '10:24:45',
    notesSleep: 'libero ut massa volutpat convallis morbi',
    notesWake: 'eleifend luctus ultricies eu nibh quisque',
  },
  {
    _id: '62a7f19efc13ae7eb800013d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-14 21:55:18',
    sleepStart: '2022-11-14 21:55:18',
    sleepEnd: '2022-11-15 09:59:28',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '12:04:10',
    notesSleep: 'tristique in tempus sit amet sem',
    notesWake: 'sagittis nam congue risus semper porta volutpat',
  },
  {
    _id: '62a7f19efc13ae7eb800013e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-15 22:51:21',
    sleepStart: '2022-11-15 22:51:21',
    sleepEnd: '2022-11-16 07:49:15',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '08:57:54',
    notesSleep: 'penatibus et magnis dis parturient montes nascetur ridiculus',
    notesWake: 'rutrum at lorem integer tincidunt ante vel',
  },
  {
    _id: '62a7f19efc13ae7eb800013f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-16 22:48:52',
    sleepStart: '2022-11-16 22:48:52',
    sleepEnd: '2022-11-17 07:26:30',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '08:37:38',
    notesSleep: 'ac neque duis bibendum morbi non quam nec',
    notesWake: 'amet consectetuer adipiscing elit proin',
  },
  {
    _id: '62a7f19efc13ae7eb8000140',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-17 21:26:54',
    sleepStart: '2022-11-17 21:26:54',
    sleepEnd: '2022-11-18 10:51:03',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 7,
    sleepDuration: '13:24:09',
    notesSleep: 'vestibulum ante ipsum primis in',
    notesWake: 'rutrum nulla tellus in sagittis',
  },
  {
    _id: '62a7f19efc13ae7eb8000141',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-18 20:26:45',
    sleepStart: '2022-11-18 20:26:45',
    sleepEnd: '2022-11-19 10:33:24',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 9,
    sleepDuration: '14:06:39',
    notesSleep: 'nunc viverra dapibus nulla suscipit',
    notesWake: 'at velit vivamus vel nulla',
  },
  {
    _id: '62a7f19efc13ae7eb8000142',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-19 20:58:40',
    sleepStart: '2022-11-19 20:58:40',
    sleepEnd: '2022-11-20 08:20:18',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '11:21:38',
    notesSleep: 'justo morbi ut odio cras',
    notesWake: 'velit vivamus vel nulla eget eros',
  },
  {
    _id: '62a7f19efc13ae7eb8000143',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-20 23:05:15',
    sleepStart: '2022-11-20 23:05:15',
    sleepEnd: '2022-11-21 09:00:53',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '09:55:38',
    notesSleep: 'quis justo maecenas rhoncus aliquam lacus morbi quis',
    notesWake: 'condimentum curabitur in libero ut massa volutpat convallis',
  },
  {
    _id: '62a7f19efc13ae7eb8000144',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-21 20:32:17',
    sleepStart: '2022-11-21 20:32:17',
    sleepEnd: '2022-11-22 06:21:20',
    moodStart: 1,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '09:49:03',
    notesSleep: 'consequat dui nec nisi volutpat',
    notesWake: 'vestibulum ac est lacinia nisi venenatis',
  },
  {
    _id: '62a7f19efc13ae7eb8000145',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-22 21:07:12',
    sleepStart: '2022-11-22 21:07:12',
    sleepEnd: '2022-11-23 10:00:13',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '12:53:01',
    notesSleep: 'pellentesque viverra pede ac diam cras',
    notesWake: 'aliquet massa id lobortis convallis tortor risus',
  },
  {
    _id: '62a7f19efc13ae7eb8000146',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-23 21:20:36',
    sleepStart: '2022-11-23 21:20:36',
    sleepEnd: '2022-11-24 09:40:23',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '12:19:47',
    notesSleep: 'ipsum primis in faucibus orci',
    notesWake: 'nullam sit amet turpis elementum ligula',
  },
  {
    _id: '62a7f19efc13ae7eb8000147',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-24 21:24:51',
    sleepStart: '2022-11-24 21:24:51',
    sleepEnd: '2022-11-25 09:47:36',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '12:22:45',
    notesSleep: 'odio condimentum id luctus nec',
    notesWake: 'nulla suscipit ligula in lacus curabitur',
  },
  {
    _id: '62a7f19efc13ae7eb8000148',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-25 23:07:58',
    sleepStart: '2022-11-25 23:07:58',
    sleepEnd: '2022-11-26 06:07:48',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '06:59:50',
    notesSleep: 'est congue elementum in hac',
    notesWake: 'vivamus metus arcu adipiscing molestie',
  },
  {
    _id: '62a7f19efc13ae7eb8000149',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-26 22:23:12',
    sleepStart: '2022-11-26 22:23:12',
    sleepEnd: '2022-11-27 07:37:35',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '09:14:23',
    notesSleep: 'pellentesque ultrices phasellus id sapien',
    notesWake: 'tempus semper est quam pharetra magna ac',
  },
  {
    _id: '62a7f19efc13ae7eb800014a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-27 21:16:14',
    sleepStart: '2022-11-27 21:16:14',
    sleepEnd: '2022-11-28 08:11:02',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '10:54:48',
    notesSleep: 'non velit donec diam neque vestibulum eget vulputate',
    notesWake: 'volutpat quam pede lobortis ligula sit amet',
  },
  {
    _id: '62a7f19efc13ae7eb800014b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-28 22:44:12',
    sleepStart: '2022-11-28 22:44:12',
    sleepEnd: '2022-11-29 10:26:46',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '11:42:34',
    notesSleep: 'nulla integer pede justo lacinia eget tincidunt',
    notesWake: 'maecenas ut massa quis augue luctus tincidunt nulla',
  },
  {
    _id: '62a7f19efc13ae7eb800014c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-29 23:49:14',
    sleepStart: '2022-11-29 23:49:14',
    sleepEnd: '2022-11-30 09:36:14',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '09:47:00',
    notesSleep: 'dui proin leo odio porttitor',
    notesWake: 'interdum mauris non ligula pellentesque ultrices phasellus',
  },
  {
    _id: '62a7f19efc13ae7eb800014d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-11-30 20:36:45',
    sleepStart: '2022-11-30 20:36:45',
    sleepEnd: '2022-12-01 09:02:31',
    moodStart: 1,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '12:25:46',
    notesSleep: 'nec euismod scelerisque quam turpis adipiscing lorem vitae',
    notesWake: 'primis in faucibus orci luctus et',
  },
  {
    _id: '62a7f19efc13ae7eb800014e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-01 20:07:26',
    sleepStart: '2022-12-01 20:07:26',
    sleepEnd: '2022-12-02 08:01:41',
    moodStart: 1,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '11:54:15',
    notesSleep: 'eget eros elementum pellentesque quisque porta',
    notesWake: 'nunc vestibulum ante ipsum primis in',
  },
  {
    _id: '62a7f19efc13ae7eb800014f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-02 23:14:39',
    sleepStart: '2022-12-02 23:14:39',
    sleepEnd: '2022-12-03 06:34:53',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 9,
    sleepDuration: '07:20:14',
    notesSleep: 'leo pellentesque ultrices mattis odio donec vitae nisi',
    notesWake: 'ut volutpat sapien arcu sed augue',
  },
  {
    _id: '62a7f19efc13ae7eb8000150',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-03 22:44:37',
    sleepStart: '2022-12-03 22:44:37',
    sleepEnd: '2022-12-04 06:25:25',
    moodStart: 0,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '07:40:48',
    notesSleep: 'cubilia curae mauris viverra diam',
    notesWake: 'diam neque vestibulum eget vulputate ut ultrices',
  },
  {
    _id: '62a7f19efc13ae7eb8000151',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-04 23:09:19',
    sleepStart: '2022-12-04 23:09:19',
    sleepEnd: '2022-12-05 09:06:16',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '09:56:57',
    notesSleep: 'montes nascetur ridiculus mus etiam',
    notesWake: 'lacinia aenean sit amet justo',
  },
  {
    _id: '62a7f19efc13ae7eb8000152',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-05 22:17:16',
    sleepStart: '2022-12-05 22:17:16',
    sleepEnd: '2022-12-06 09:47:17',
    moodStart: 4,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '11:30:01',
    notesSleep: 'sapien cum sociis natoque penatibus et magnis',
    notesWake: 'aenean fermentum donec ut mauris eget massa',
  },
  {
    _id: '62a7f19efc13ae7eb8000153',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-06 21:59:37',
    sleepStart: '2022-12-06 21:59:37',
    sleepEnd: '2022-12-07 06:42:16',
    moodStart: 1,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '08:42:39',
    notesSleep: 'adipiscing elit proin interdum mauris non ligula pellentesque',
    notesWake: 'phasellus in felis donec semper',
  },
  {
    _id: '62a7f19efc13ae7eb8000154',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-07 21:53:53',
    sleepStart: '2022-12-07 21:53:53',
    sleepEnd: '2022-12-08 09:43:46',
    moodStart: 2,
    moodWake: 4,
    sleepGoal: 6,
    sleepDuration: '11:49:53',
    notesSleep: 'nisl duis ac nibh fusce lacus purus',
    notesWake: 'a suscipit nulla elit ac nulla',
  },
  {
    _id: '62a7f19efc13ae7eb8000155',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-08 22:00:58',
    sleepStart: '2022-12-08 22:00:58',
    sleepEnd: '2022-12-09 06:50:19',
    moodStart: 1,
    moodWake: 1,
    sleepGoal: 8,
    sleepDuration: '08:49:21',
    notesSleep: 'dui luctus rutrum nulla tellus in',
    notesWake: 'felis fusce posuere felis sed lacus morbi sem',
  },
  {
    _id: '62a7f19efc13ae7eb8000156',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-09 23:03:00',
    sleepStart: '2022-12-09 23:03:00',
    sleepEnd: '2022-12-10 06:53:27',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '07:50:27',
    notesSleep: 'nisi at nibh in hac',
    notesWake: 'in porttitor pede justo eu massa donec dapibus',
  },
  {
    _id: '62a7f19efc13ae7eb8000157',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-10 22:42:46',
    sleepStart: '2022-12-10 22:42:46',
    sleepEnd: '2022-12-11 09:30:39',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '10:47:53',
    notesSleep: 'leo odio porttitor id consequat in consequat ut',
    notesWake: 'pellentesque eget nunc donec quis',
  },
  {
    _id: '62a7f19efc13ae7eb8000158',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-11 21:28:29',
    sleepStart: '2022-12-11 21:28:29',
    sleepEnd: '2022-12-12 09:11:25',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '11:42:56',
    notesSleep: 'ante ipsum primis in faucibus orci luctus',
    notesWake: 'sagittis dui vel nisl duis',
  },
  {
    _id: '62a7f19efc13ae7eb8000159',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-12 22:01:18',
    sleepStart: '2022-12-12 22:01:18',
    sleepEnd: '2022-12-13 09:12:18',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 9,
    sleepDuration: '11:11:00',
    notesSleep: 'at nibh in hac habitasse platea',
    notesWake: 'aenean fermentum donec ut mauris',
  },
  {
    _id: '62a7f19efc13ae7eb800015a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-13 21:51:39',
    sleepStart: '2022-12-13 21:51:39',
    sleepEnd: '2022-12-14 09:43:44',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 7,
    sleepDuration: '11:52:05',
    notesSleep: 'quisque arcu libero rutrum ac lobortis vel',
    notesWake: 'lobortis ligula sit amet eleifend pede',
  },
  {
    _id: '62a7f19efc13ae7eb800015b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-14 21:32:04',
    sleepStart: '2022-12-14 21:32:04',
    sleepEnd: '2022-12-15 09:23:07',
    moodStart: 1,
    moodWake: 2,
    sleepGoal: 6,
    sleepDuration: '11:51:03',
    notesSleep: 'in tempus sit amet sem',
    notesWake: 'aliquet massa id lobortis convallis tortor risus dapibus',
  },
  {
    _id: '62a7f19efc13ae7eb800015c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-15 21:08:22',
    sleepStart: '2022-12-15 21:08:22',
    sleepEnd: '2022-12-16 09:36:58',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '12:28:36',
    notesSleep: 'elementum nullam varius nulla facilisi',
    notesWake: 'sapien a libero nam dui',
  },
  {
    _id: '62a7f19efc13ae7eb800015d',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-16 20:10:46',
    sleepStart: '2022-12-16 20:10:46',
    sleepEnd: '2022-12-17 08:19:23',
    moodStart: 3,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '12:08:37',
    notesSleep: 'posuere cubilia curae donec pharetra magna vestibulum',
    notesWake: 'convallis duis consequat dui nec nisi volutpat',
  },
  {
    _id: '62a7f19efc13ae7eb800015e',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-17 21:03:30',
    sleepStart: '2022-12-17 21:03:30',
    sleepEnd: '2022-12-18 09:51:51',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 8,
    sleepDuration: '12:48:21',
    notesSleep: 'tortor quis turpis sed ante',
    notesWake: 'tellus nulla ut erat id mauris',
  },
  {
    _id: '62a7f19efc13ae7eb800015f',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-18 20:35:09',
    sleepStart: '2022-12-18 20:35:09',
    sleepEnd: '2022-12-19 08:58:39',
    moodStart: 3,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '12:23:30',
    notesSleep:
      'aliquam augue quam sollicitudin vitae consectetuer eget rutrum',
    notesWake: 'justo in hac habitasse platea',
  },
  {
    _id: '62a7f19efc13ae7eb8000160',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-19 20:23:41',
    sleepStart: '2022-12-19 20:23:41',
    sleepEnd: '2022-12-20 07:59:11',
    moodStart: 4,
    moodWake: 4,
    sleepGoal: 9,
    sleepDuration: '11:35:30',
    notesSleep: 'vel lectus in quam fringilla rhoncus',
    notesWake: 'tincidunt eget tempus vel pede morbi porttitor lorem',
  },
  {
    _id: '62a7f19efc13ae7eb8000161',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-20 21:50:39',
    sleepStart: '2022-12-20 21:50:39',
    sleepEnd: '2022-12-21 10:16:09',
    moodStart: 3,
    moodWake: 1,
    sleepGoal: 9,
    sleepDuration: '12:25:30',
    notesSleep: 'nunc vestibulum ante ipsum primis',
    notesWake: 'lectus vestibulum quam sapien varius',
  },
  {
    _id: '62a7f19efc13ae7eb8000162',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-21 22:59:30',
    sleepStart: '2022-12-21 22:59:30',
    sleepEnd: '2022-12-22 08:11:58',
    moodStart: 4,
    moodWake: 2,
    sleepGoal: 8,
    sleepDuration: '09:12:28',
    notesSleep: 'massa quis augue luctus tincidunt',
    notesWake: 'sit amet sapien dignissim vestibulum vestibulum ante ipsum',
  },
  {
    _id: '62a7f19efc13ae7eb8000163',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-22 22:58:56',
    sleepStart: '2022-12-22 22:58:56',
    sleepEnd: '2022-12-23 10:37:12',
    moodStart: 2,
    moodWake: 2,
    sleepGoal: 7,
    sleepDuration: '11:38:16',
    notesSleep: 'ut dolor morbi vel lectus',
    notesWake: 'posuere metus vitae ipsum aliquam',
  },
  {
    _id: '62a7f19efc13ae7eb8000164',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-23 21:04:04',
    sleepStart: '2022-12-23 21:04:04',
    sleepEnd: '2022-12-24 09:33:32',
    moodStart: 4,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '12:29:28',
    notesSleep: 'id sapien in sapien iaculis congue',
    notesWake: 'sem sed sagittis nam congue risus',
  },
  {
    _id: '62a7f19efc13ae7eb8000165',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-24 20:24:11',
    sleepStart: '2022-12-24 20:24:11',
    sleepEnd: '2022-12-25 06:32:50',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 6,
    sleepDuration: '10:08:39',
    notesSleep: 'justo sollicitudin ut suscipit a',
    notesWake: 'nulla nisl nunc nisl duis bibendum',
  },
  {
    _id: '62a7f19efc13ae7eb8000166',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-25 22:22:17',
    sleepStart: '2022-12-25 22:22:17',
    sleepEnd: '2022-12-26 06:45:48',
    moodStart: 4,
    moodWake: 3,
    sleepGoal: 8,
    sleepDuration: '08:23:31',
    notesSleep: 'felis eu sapien cursus vestibulum proin',
    notesWake: 'vestibulum quam sapien varius ut blandit non',
  },
  {
    _id: '62a7f19efc13ae7eb8000167',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-26 23:56:02',
    sleepStart: '2022-12-26 23:56:02',
    sleepEnd: '2022-12-27 08:59:22',
    moodStart: 0,
    moodWake: 1,
    sleepGoal: 7,
    sleepDuration: '09:03:20',
    notesSleep: 'ridiculus mus etiam vel augue vestibulum rutrum rutrum',
    notesWake: 'pede justo eu massa donec dapibus duis at',
  },
  {
    _id: '62a7f19efc13ae7eb8000168',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-27 20:01:02',
    sleepStart: '2022-12-27 20:01:02',
    sleepEnd: '2022-12-28 07:08:19',
    moodStart: 3,
    moodWake: 4,
    sleepGoal: 8,
    sleepDuration: '11:07:17',
    notesSleep: 'pharetra magna ac consequat metus sapien',
    notesWake: 'tellus nisi eu orci mauris lacinia sapien',
  },
  {
    _id: '62a7f19efc13ae7eb8000169',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-28 20:15:18',
    sleepStart: '2022-12-28 20:15:18',
    sleepEnd: '2022-12-29 07:59:02',
    moodStart: 0,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '11:43:44',
    notesSleep: 'sodales scelerisque mauris sit amet',
    notesWake: 'purus phasellus in felis donec',
  },
  {
    _id: '62a7f19efc13ae7eb800016a',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-29 20:38:39',
    sleepStart: '2022-12-29 20:38:39',
    sleepEnd: '2022-12-30 08:45:01',
    moodStart: 2,
    moodWake: 0,
    sleepGoal: 6,
    sleepDuration: '12:06:22',
    notesSleep: 'lacus purus aliquet at feugiat non pretium quis',
    notesWake: 'cubilia curae donec pharetra magna vestibulum',
  },
  {
    _id: '62a7f19efc13ae7eb800016b',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-30 23:10:20',
    sleepStart: '2022-12-30 23:10:20',
    sleepEnd: '2022-12-31 09:55:43',
    moodStart: 1,
    moodWake: 4,
    sleepGoal: 7,
    sleepDuration: '10:45:23',
    notesSleep: 'nam dui proin leo odio porttitor id consequat',
    notesWake: 'cursus urna ut tellus nulla ut erat',
  },
  {
    _id: '62a7f19efc13ae7eb800016c',
    creator: '623300e3f0323969f1010b28',
    date: '2022-12-31 21:23:05',
    sleepStart: '2022-12-31 21:23:05',
    sleepEnd: '2023-01-01 06:39:04',
    moodStart: 2,
    moodWake: 1,
    sleepGoal: 6,
    sleepDuration: '09:15:59',
    notesSleep: 'sapien placerat ante nulla justo aliquam',
    notesWake: 'habitasse platea dictumst etiam faucibus cursus',
  },
];

export default mockSleepData;
